'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
(function () {
  Entry.CodeWizLite = new (/*#__PURE__*/function () {
    function CodeWizLite() {
      (0, _classCallCheck2["default"])(this, CodeWizLite);
      this.id = '011201';
      this.name = 'CodeWizLite';
      this.url = 'https://www.codable.co.kr';
      this.imageName = 'codewizlite.png';
      this.title = {
        ko: '코드위즈',
        en: 'CodeWiz'
      };
      this.duration = 32;
      this.portData = {
        baudRate: 115200,
        duration: 32,
        dataBits: 8,
        parity: 'none',
        stopBits: 1,
        bufferSize: 512,
        constantServing: true
      };
      this.receiveType = {
        SENSOR_TYPE1: 0,
        SENSOR_TYPE2: 1,
        HUSKY_RESULTS: 2,
        BOOLEAN: 3,
        INT: 4,
        FLOAT: 5,
        RUN_OK: 6
      };
      this.defaultSensorList = ['SOUND', 'LIGHT', 'DIST', 'HALL'];
      this.defaultSensorList2 = ['touchPin_13', 'touchPin_14', 'touchPin_15', 'touchPin_27', 'touchPin_32', 'touchPin_33', 'switchButton_4', 'switchButton_26', 'GYRO_X', 'GYRO_Y', 'GYRO_Z', 'tempSensor'];
      this.isDraing = false;
      this.isFirst = true;
      this.blockMenuBlocks = ['CodeWizLite_sensor_title', 'CodeWizLite_get_sensor', 'CodeWizLite_get_gyroSensor', 'CodeWizLite_isPushedButton', 'CodeWizLite_touchPin', 'CodeWizLite_buzzer_title', 'CodeWizLite_default_buzzer', 'CodeWizLite_neopixel_title', 'CodeWizLite_neopixel_init', 'CodeWizLite_neopixel_brightness', 'CodeWizLite_neopixel_setColor_one', 'CodeWizLite_neopixel_setColor_one2', 'CodeWizLite_neopixel_off_one', 'CodeWizLite_neopixel_setColor_all', 'CodeWizLite_neopixel_setColor_all2', 'CodeWizLite_neopixel_off_all', 'CodeWizLite_neopixel_OnPixelRandomColor', 'CodeWizLite_neopixel_fillRandom', 'CodeWizLite_neopixel_rotate', 'CodeWizLite_neopixel_shift', 'CodeWizLite_neopixel_gradationRGB', 'CodeWizLite_neopixel_gradationHSL', 'CodeWizLite_neopixel_wheeeeeeel', 'CodeWizLite_OLED_title', 'CodeWizLite_OLED_clear', 'CodeWizLite_OLED_mirror', 'CodeWizLite_OLED_setSize', 'CodeWizLite_OLED_setPosition', 'CodeWizLite_OLED_println', 'CodeWizLite_OLED_isCollision', 'CodeWizLite_OLED_specialChar', 'CodeWizLite_OLED_setFont', 'CodeWizLite_OLED_startScroll', 'CodeWizLite_OLED_stopScroll', 'CodeWizLite_OLED_drawPoint', 'CodeWizLite_OLED_drawLine1', 'CodeWizLite_OLED_drawLine2', 'CodeWizLite_OLED_drawLine3', 'CodeWizLite_OLED_drawRect', 'CodeWizLite_OLED_drawCircle', 'CodeWizLite_OLED_drawPoligon', 'CodeWizLite_OLED_printHG', 'CodeWizLite_DIGITAL_OUTPUT_title', 'CodeWizLite_DIGITAL_OUTPUT_digitalWrite', 'CodeWizLite_DIGITAL_OUTPUT_pwmWrite', 'CodeWizLite_OzEye_title', 'CodeWizLite_OzEye_initOzEye', 'CodeWizLite_OzEye_setModeOfOzEye', 'CodeWizLite_OzEye_readOzEye', 'CodeWizLite_OzEye_isLearnedOzEye', 'CodeWizLite_OzEye_isContainOzEye', 'CodeWizLite_OzEye_getCountLearnedOzEye', 'CodeWizLite_OzEye_hasTypeOzEye', 'CodeWizLite_OzEye_getArrowInfoOzEye', 'CodeWizLite_OzEye_getBoxInfoOzEye2', 'CodeWizLite_OzEye_getBoxInfoOzEye',
      // 'CodeWizLite_OzEye_writeTextOzEye',
      // 'CodeWizLite_OzEye_clearTextOzEye',
      'CodeWizLite_OzEye_setLightLevel', 'CodeWizLite_OzEye_LightOff', 'CodeWizLite_HuskyLens_title', 'CodeWizLite_HuskyLens_initHuskyLens', 'CodeWizLite_HuskyLens_setModeOfHuskyLens', 'CodeWizLite_HuskyLens_readHuskyLens', 'CodeWizLite_HuskyLens_isLearnedHuskyLens', 'CodeWizLite_HuskyLens_isContainHuskyLens', 'CodeWizLite_HuskyLens_getCountLearnedHuskyLens', 'CodeWizLite_HuskyLens_hasTypeHuskyLens', 'CodeWizLite_HuskyLens_getArrowInfoHuskyLens', 'CodeWizLite_HuskyLens_getBoxInfoHuskyLens2', 'CodeWizLite_HuskyLens_getBoxInfoHuskyLens', 'CodeWizLite_HuskyLens_writeTextHuskyLens', 'CodeWizLite_HuskyLens_clearTextHuskyLens', 'CodeWizLite_Servo_title', 'CodeWizLite_Servo_setAngle', 'CodeWizLite_Servo_menuSpeed', 'CodeWizLite_Servo_customSpeed', 'CodeWizLite_Dc_title', 'CodeWizLite_Dc_setCarSpeed', 'CodeWizLite_Dc_setValue_Waterpump', 'CodeWizLite_DotMatrix_title', 'CodeWizLite_DotMatrix_init', 'CodeWizLite_DotMatrix_setBrightness', 'CodeWizLite_DotMatrix_printString', 'CodeWizLite_DotMatrix_setLine',
      // 'CodeWizLite_DotMatrix_Show_Custom_Image',
      'CodeWizLite_DotMatrix_setDot', 'CodeWizLite_DotMatrix_clear', 'CodeWizLite_DotMatrix_clearAll', 'CodeWizLite_ColorSensor_title', 'CodeWizLite_ColorSensor_isColor', 'CodeWizLite_ColorSensor_getColorValue', 'CodeWizLite_DHT_title', 'CodeWizLite_DHT_init', 'CodeWizLite_DHT_getValue', 'CodeWizLite_Joystick_title', 'CodeWizLite_Joystick_setPin', 'CodeWizLite_Joystick_readAxis', 'CodeWizLite_Joystick_readButton', 'CodeWizLite_etcReadSensor_title', 'CodeWizLite_etcReadSensor_mconRead', 'CodeWizLite_etcReadSensor_digitalRead', 'CodeWizLite_etcReadSensor_InfraredThermometerRead'];
      this.sensorTypes = {
        READ: 1,
        WRITE: 0
      };
      this.setZero();
    }
    return (0, _createClass2["default"])(CodeWizLite, [{
      key: "__sleep",
      value: function __sleep(ms) {
        return new Promise(function (resolve) {
          return setTimeout(resolve, ms);
        });
      }

      // 하드웨어 연결 후 초기화를 위한 함수입니다.
    }, {
      key: "initialHandshake",
      value: function () {
        var _initialHandshake = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
          var runApp0;
          return _regenerator["default"].wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                runApp0 = [0xc0, 0x00, 0xe0, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0xc0]; // DTR과 RTS 설정
                _context.next = 1;
                return Entry.hwLite.serial.port.setSignals({
                  dataTerminalReady: false,
                  requestToSend: true
                });
              case 1:
                _context.next = 2;
                return this.__sleep(200);
              case 2:
                _context.next = 3;
                return Entry.hwLite.serial.port.setSignals({
                  dataTerminalReady: true,
                  requestToSend: false
                });
              case 3:
                _context.next = 4;
                return this.__sleep(800);
              case 4:
                _context.next = 5;
                return Entry.hwLite.serial.port.setSignals({
                  dataTerminalReady: false,
                  requestToSend: false
                });
              case 5:
                _context.next = 6;
                return this.__sleep(1000);
              case 6:
                _context.next = 7;
                return Entry.hwLite.serial.sendAsync(runApp0);
              case 7:
                return _context.abrupt("return", true);
              case 8:
              case "end":
                return _context.stop();
            }
          }, _callee, this);
        }));
        function initialHandshake() {
          return _initialHandshake.apply(this, arguments);
        }
        return initialHandshake;
      }() // 시작하기 및 정지하기 시 기기상태를 초기화하기 위한 함수입니다.
    }, {
      key: "setZero",
      value: function setZero() {
        this.sendBuffers = [];
        this.recvBuffers = [];
        this.sensorData = {
          SOUND: 0,
          LIGHT: 0,
          DIST: 0,
          HALL: 0,
          touchPin_13: 0,
          touchPin_14: 0,
          touchPin_15: 0,
          touchPin_27: 0,
          touchPin_32: 0,
          touchPin_33: 0,
          switchButton_4: 0,
          switchButton_26: 0,
          tempSensor: 0.0,
          GYRO_X: 0,
          GYRO_Y: 0,
          GYRO_Z: 0,
          HUSKY_READ: {
            _type: 0,
            _count: 0,
            _list: []
          }
        };
        this.HUSKY = {
          CENT_X: 160,
          CENT_Y: 120,
          getDist: function getDist(x, y) {
            return Math.sqrt(Math.pow(this.CENT_X - x, 2) + Math.pow(this.CENT_Y - y, 2));
          }
        };
        this.sendQueue = {
          ORDER: {},
          RESET: 1
        };
        if (Entry.hwLite && Entry.hwLite.serial) {
          var reset = [254, 255, 3, 1, 0];
          Entry.hwLite.serial.sendAsync(reset);
        }
      }

      // 기기로부터 값을 읽어서 WS에 반영하는 함수입니다. (기기로부터값 읽음)
      //this.portData.constantServing일 경우 사용합니다.
    }, {
      key: "handleLocalData",
      value: function handleLocalData(data) {
        var _this = this;
        var datas = this.getDataByBuffer(data);
        datas.forEach(function (readData) {
          var value;
          switch (readData[1]) {
            case _this.receiveType.SENSOR_TYPE1:
              {
                for (var i = 1; 2 * i < readData.length; ++i) {
                  value = readData[i * 2] << 8 | readData[i * 2 + 1];
                  if (i === 3) {
                    if (value < 3000) {
                      Entry.CodeWizLite.sensorData.DIST = value;
                    }
                  } else if (i === 4) {
                    Entry.CodeWizLite.sensorData.HALL = value - 300;
                  } else {
                    _this.sensorData[_this.defaultSensorList[i - 1]] = value;
                  }
                }
                _this.shouldUpdateSensor1 = true;
                return;
              }
            case _this.receiveType.SENSOR_TYPE2:
              {
                var _value;
                for (var _i = 0; _i < 8; ++_i) {
                  _value = readData[2] >> _i & 1;
                  _this.sensorData[_this.defaultSensorList2[_i]] = _value === 1;
                }
                for (var _i2 = 8; _i2 < 8 + 3; ++_i2) {
                  _value = readData[_i2 - 5];
                  if (_value <= 180) {
                    _this.sensorData[_this.defaultSensorList2[_i2]] = _value - 90;
                  }
                }
                //temperature
                _value = readData[6] << 8 | readData[7];
                _value -= 400;
                _value /= 10.0;
                if (_value < 81) {
                  _this.sensorData[_this.defaultSensorList2[11]] = _value;
                }
                _this.shouldUpdateSensor2 = true;
                return;
              }
            case _this.receiveType.HUSKY_RESULTS:
              {
                Entry.CodeWizLite.sensorData.HUSKY_READ._type = readData[2];
                Entry.CodeWizLite.sensorData.HUSKY_READ._count = readData[3];
                Entry.CodeWizLite.sensorData.HUSKY_READ._list = [];
                for (var _i3 = 0; _i3 < readData[3]; ++_i3) {
                  Entry.CodeWizLite.sensorData.HUSKY_READ._list.push([readData[9 * _i3 + 4], readData[9 * _i3 + 5] << 8 | readData[9 * _i3 + 6], readData[9 * _i3 + 7] << 8 | readData[9 * _i3 + 8], readData[9 * _i3 + 9] << 8 | readData[9 * _i3 + 10], readData[9 * _i3 + 11] << 8 | readData[9 * _i3 + 12]]);
                }
                _this.shouldUpdateHusky = true;
                return;
              }
            case _this.receiveType.RUN_OK:
              {
                // this.handler.write(this.curId, { value: 'runOK' });
                _this.sensorData[_this.curId] = {
                  value: 'runOK'
                };
                return;
              }
            case _this.receiveType.BOOLEAN:
              {
                // this.handler.write(this.curId, { value: readData[2] === 1 });
                _this.sensorData[_this.curId] = {
                  value: readData[2] === 1
                };
                return;
              }
            case _this.receiveType.INT:
              {
                var _sign = readData[2] === 1;
                var _value2 = readData[3] << 8 | readData[4];
                if (_sign) {
                  _value2 *= -1;
                }
                // this.handler.write(this.curId, { value: _value });
                _this.sensorData[_this.curId] = {
                  value: _value2
                };
                return;
              }
            case _this.receiveType.FLOAT:
              {
                var _sign2 = readData[2] & 0x80; // -: 1, +:0
                var firstData = readData[2] & 0x7f;
                var _value3 = firstData << 8 | readData[3];
                if (_sign2 === 1) {
                  _value3 *= -1;
                }
                _value3 /= 10;
                // this.handler.write(this.curId, { value: _value });
                _this.sensorData[_this.curId] = {
                  value: _value3
                };
                return;
              }
            default:
              {
                return;
              }
          }
        });
      }

      /*
      하드웨어 기기에 전달할 데이터를 반환합니다.
      slave 모드인 경우 duration 속성 간격으로 지속적으로 기기에 요청을 보냅니다.
      */

      //WS의 블록동작의 명령을 기기에게 쓰는 함수입니다. (기기에 값 쓰기)
      //this.portData.constantServing일 경우 사용합니다
    }, {
      key: "requestLocalData",
      value: function requestLocalData() {
        if (this.sendBuffers.length > 0) {
          var dataToSend = this.sendBuffers.shift();
          return dataToSend;
        }
        return null;
      }
    }, {
      key: "getHashKey",
      value: function getHashKey(opcode) {
        // let key = new Date().getSeconds().toString(16);
        // if (key.length === 1) {
        //     key += ((Math.random() * 16) | 0).toString(16);
        // }
        // return Entry.generateHash(6) + opcode;
        // Symbol을 쓰면 hw로 넘길수있나 -> 있으면 지금과 비교해서 속도는?
        return Date.now().toString().substring(6) + opcode;
      }

      // 코드위즈에 보낼 데이터를 만드는 함수입니다.
    }, {
      key: "sendOrder",
      value: function sendOrder(order) {
        var _this2 = this;
        Entry.CodeWizLite.intervalId = true;
        var id = this.getHashKey(order.value.opcode);
        this.sendQueue.ORDER[id] = order;
        Entry.hwLite.serial.update();
        var buffer = null;
        if (this.sendQueue.ORDER) {
          var keys = Object.keys(this.sendQueue.ORDER);
          keys.forEach(function (id) {
            var data = _this2.sendQueue.ORDER[id];
            if (data) {
              var _buffer;
              buffer = _this2.makeSendMessage(data.type, data.value);
              if (((_buffer = buffer) === null || _buffer === void 0 ? void 0 : _buffer.length) > 0) {
                _this2.sendBuffers.push(buffer);
                _this2.curId = id;
              }
            }
          });
        }
        this.deleteOrder(id);
        return id;
      }
    }, {
      key: "deleteOrder",
      value: function deleteOrder(id) {
        Entry.CodeWizLite.sensorData[id] = {
          value: null
        };
        delete this.sendQueue.ORDER[id];
        Entry.hwLite.serial.update();
      }
    }, {
      key: "getOffsetX",
      value: function getOffsetX(str) {
        return this.getByteLength(str) * 1.5 - 18;
      }
    }, {
      key: "getByteLength",
      value: function getByteLength(s, b, i, c) {
        if (!s) {
          return;
        }
        for (b = i = 0; c = s.charCodeAt(i++); b += c >> 11 ? 3 : c >> 7 ? 2 : 1);
        return b;
      }
    }, {
      key: "getMonitorPort",
      value: function getMonitorPort() {
        return _objectSpread({}, this.sensorData);
      }
    }, {
      key: "monitorTemplate",
      get: function get() {
        return {
          imgPath: 'hw_lite/codewizlite.png',
          width: 200,
          height: 200,
          mode: 'both'
        };
      }
    }, {
      key: "processData",
      value: function processData(dataArr) {
        var retVal = [];
        for (var i = 0; i < dataArr.length; ++i) {
          retVal.push.apply(retVal, (0, _toConsumableArray2["default"])(this.strToAscii('' + dataArr[i])));
        }
        return retVal;
      }
    }, {
      key: "strToAscii",
      value: function strToAscii(str) {
        if (!str) {
          return [];
        }
        // let ret = [str.length];
        var ret = [];
        for (var i = 0; i < str.length; ++i) {
          // ret.push(str[i].charCodeAt());
          var c = str[i].charCodeAt();
          if (c > 0xff) {
            ret.push(0x08, c >> 8, c & 0xff);
          } else {
            ret.push(c);
          }
        }
        ret.unshift(ret.length);
        return ret;
      }
    }, {
      key: "makeSendMessage",
      value: function makeSendMessage(type, data) {
        if (!$.isPlainObject(data)) {
          return null;
        }
        var buffer = this.addHeader(type, [data.opcode].concat((0, _toConsumableArray2["default"])(this.processData(data.params))));
        // console.log('makeSendMessage:', buffer);
        return buffer;
      }
    }, {
      key: "addHeader",
      value: function addHeader(actionType, data) {
        return [254, 255, data.length + 2, actionType].concat((0, _toConsumableArray2["default"])(data));
      }
    }, {
      key: "getDataByBuffer",
      value: function getDataByBuffer(buffer) {
        var _this$recvBuffers;
        (_this$recvBuffers = this.recvBuffers).push.apply(_this$recvBuffers, (0, _toConsumableArray2["default"])(buffer));
        var datas = [];
        var lastIdx = 0;
        this.recvBuffers.forEach(function (value, idx, d) {
          if (value === 0xff && d[idx + 1] === 0xfe) {
            lastIdx = idx + 2 + d[idx + 2];
            datas.push(d.slice(idx + 2, lastIdx));
          }
        });
        this.recvBuffers.splice(0, lastIdx);
        return datas;
      }
    }, {
      key: "preWait",
      value: function preWait() {
        return new Promise(function (resolve) {
          var tmp = setInterval(function () {
            // console.log('preWait:', Entry.CodeWizLite.intervalId);
            if (!Entry.CodeWizLite.intervalId) {
              clearInterval(tmp);
              // Entry.CodeWizLite.preWaitResult = Entry.CodeWizLite.preWaitList.shift() || null;
              resolve();
            }
          }, 11);
        });
      }
    }, {
      key: "checkComplete",
      value: function checkComplete(timeout, id) {
        var _promise = new Promise(function (resolve) {
          timeout = timeout !== null && timeout !== void 0 ? timeout : 1000;
          Entry.CodeWizLite.intervalId = setInterval(function () {
            var _Entry$CodeWizLite$se;
            // console.log(Entry.CodeWizLite.intervalId, 'runOK:', Entry.CodeWizLite.sensorData[id]);
            var ret = (_Entry$CodeWizLite$se = Entry.CodeWizLite.sensorData[id]) === null || _Entry$CodeWizLite$se === void 0 ? void 0 : _Entry$CodeWizLite$se.value;
            if (ret !== undefined && ret !== null) {
              clearInterval(Entry.CodeWizLite.intervalId);
              clearTimeout(Entry.CodeWizLite.timeoutId);
              Entry.CodeWizLite.intervalId = null;
              Entry.CodeWizLite.timeoutId = null;
              resolve();
            }
          }, 7);
          Entry.CodeWizLite.timeoutId = setTimeout(function () {
            clearInterval(Entry.CodeWizLite.intervalId);
            // console.log(Entry.CodeWizLite.intervalId, 'timeOut');
            Entry.CodeWizLite.intervalId = null;
            Entry.CodeWizLite.timeoutId = null;
            // throw new Entry.Utils.AsyncError('TimeOutOccurred');
            resolve();
          }, timeout);
        });
        return _promise;
      }
    }, {
      key: "setLanguage",
      value: function setLanguage() {
        return {
          ko: {
            template: {
              CodeWizLite_sensor_title: '기본 센서',
              CodeWizLite_get_sensor: '%1센서 값',
              CodeWizLite_get_gyroSensor: '3축 센서 %1값',
              CodeWizLite_isPushedButton: '%1 스위치 버튼 값',
              CodeWizLite_touchPin: '터치핀 %1 값',
              CodeWizLite_buzzer_title: '스피커',
              CodeWizLite_default_buzzer: '스피커를 %1옥타브, %2음, %3분음표로 연주하기 %4',
              CodeWizLite_neopixel_title: '네오픽셀',
              CodeWizLite_neopixel_init: '네오픽셀 %1에 %2개로 시작설정%3',
              CodeWizLite_neopixel_brightness: '네오픽셀 밝기를 %1로 설정(0~255)%2',
              CodeWizLite_neopixel_setColor_one: '네오픽셀 %1번 LED를 %2(으)로 켜기%3',
              CodeWizLite_neopixel_setColor_one2: '네오픽셀 %1번 LED를 빨강%2초록%3파랑%4(으)로 켜기%5',
              CodeWizLite_neopixel_off_one: '네오픽셀 %1번 LED 끄기%2',
              CodeWizLite_neopixel_setColor_all: '네오픽셀 %1(으)로 모두 켜기%2',
              CodeWizLite_neopixel_setColor_all2: '네오픽셀 빨강%1초록%2파랑%3(으)로 모두 켜기%4',
              CodeWizLite_neopixel_off_all: '네오픽셀 모두 끄기%1',
              CodeWizLite_neopixel_OnPixelRandomColor: '네오픽셀 %1번 LED 무작위 색으로 켜기%2',
              CodeWizLite_neopixel_fillRandom: '네오픽셀 무작위 색으로 채우기%1',
              CodeWizLite_neopixel_rotate: '네오픽셀 LED %1으로 회전시키기%2',
              CodeWizLite_neopixel_shift: '네오픽셀 LED %1으로 밀기%2',
              CodeWizLite_neopixel_gradationRGB: '네오픽셀 %1번부터 %2번까지 RGB그라데이션(%3,%4)으로 켜기%5',
              CodeWizLite_neopixel_gradationHSL: '네오픽셀 %1번부터 %2번까지 HSL그라데이션(%3,%4)으로 켜기%5',
              CodeWizLite_neopixel_wheeeeeeel: '네오픽셀 휠%1',
              CodeWizLite_OLED_title: 'OLED',
              CodeWizLite_OLED_clear: 'OLED 지우기%1',
              CodeWizLite_OLED_mirror: 'OLED 반전 모드%1 %2',
              CodeWizLite_OLED_setSize: 'OLED 문자 크기를 %1(으)로 설정%2',
              CodeWizLite_OLED_setPosition: 'OLED 커서위치(%1,%2)(으)로 지정%3',
              CodeWizLite_OLED_println: 'OLED에 %1 출력%2',
              CodeWizLite_OLED_isCollision: 'OLED 자동 줄바꿈%1%2',
              CodeWizLite_OLED_specialChar: 'OLED에 기호%1 출력하기%2',
              CodeWizLite_OLED_setFont: 'OLED 폰트%1를 크기%2(으)로 설정%3',
              CodeWizLite_OLED_startScroll: 'OLED 스크롤 시키기%1 시작%2~종료%3(0~7)%4',
              CodeWizLite_OLED_stopScroll: 'OLED 스크롤 멈추기%1',
              CodeWizLite_OLED_drawPoint: 'OLED 점찍기 (%1,%2)%3%4',
              CodeWizLite_OLED_drawLine1: 'OLED 선 그리기 시작(%1,%2) 끝(%3,%4)%5%6',
              CodeWizLite_OLED_drawLine2: 'OLED 수직선 시작(%1,%2) 길이%3%4%5',
              CodeWizLite_OLED_drawLine3: 'OLED 수평선 시작(%1,%2) 길이%3%4%5',
              CodeWizLite_OLED_drawRect: 'OLED 직사각형 시작(%1,%2) 가로%3세로%4%5%6%7',
              CodeWizLite_OLED_drawCircle: 'OLED 원 중심(%1,%2) 반지름%3%4%5%6',
              CodeWizLite_OLED_drawPoligon: 'OLED 삼각형 점1(%1,%2)점2(%3,%4)점3(%5,%6)%7%8%9',
              CodeWizLite_OLED_printHG: 'OLED에 한글포함%1 출력, 줄바꿈%2%3',
              CodeWizLite_DIGITAL_OUTPUT_title: '기본 출력',
              CodeWizLite_DIGITAL_OUTPUT_digitalWrite: 'PIN%1(으)로 %2내보내기%3',
              CodeWizLite_DIGITAL_OUTPUT_pwmWrite: 'PIN%1(으)로 PWM %2내보내기(0~1023)%3',
              CodeWizLite_OzEye_title: '오즈아이',
              CodeWizLite_OzEye_initOzEye: '오즈아이 시작설정%1',
              CodeWizLite_OzEye_setModeOfOzEye: '오즈아이 %1알고리즘으로 설정%2',
              CodeWizLite_OzEye_readOzEye: '오즈아이 데이터 요청시작%1',
              CodeWizLite_OzEye_isLearnedOzEye: '오즈아이 ID가%1인 데이터를 학습했는가?%2',
              CodeWizLite_OzEye_getCountLearnedOzEye: '오즈아이가 감지한 학습데이터 수%1',
              CodeWizLite_OzEye_isContainOzEye: '오즈아이 ID:%1로 인식한 %2데이터가 있는가?%3',
              CodeWizLite_OzEye_hasTypeOzEye: '오즈아이가 읽은 데이터 타입이%1인가?%2',
              CodeWizLite_OzEye_getArrowInfoOzEye: '오즈아이가 읽은 ID%1인 화살표정보%2%3',
              CodeWizLite_OzEye_getBoxInfoOzEye2: '오즈아이가 읽은 ID%1인 사각형정보%2%3',
              CodeWizLite_OzEye_getBoxInfoOzEye: '오즈아이가 읽은 사각형정보%1(중심좌표가 중앙에 가장 가까운 것)%2',
              // CodeWizLite_OzEye_writeTextOzEye: '오즈아이 (%1,%2)에 %3출력%4',
              // CodeWizLite_OzEye_clearTextOzEye: '오즈아이 텍스트 지우기%1',
              CodeWizLite_OzEye_setLightLevel: '오즈아이 라이트 밝기를 %1 단계로 설정(1~7)%2',
              CodeWizLite_OzEye_LightOff: '오즈아이 라이트 끄기%1',
              CodeWizLite_HuskyLens_title: '허스키렌즈',
              CodeWizLite_HuskyLens_initHuskyLens: '허스키렌즈 시작설정%1',
              CodeWizLite_HuskyLens_setModeOfHuskyLens: '허스키렌즈 %1알고리즘으로 설정%2',
              CodeWizLite_HuskyLens_readHuskyLens: '허스키렌즈 데이터 요청시작%1',
              CodeWizLite_HuskyLens_isLearnedHuskyLens: '허스키렌즈 ID가%1인 데이터를 학습했는가?%2',
              CodeWizLite_HuskyLens_getCountLearnedHuskyLens: '허스키렌즈가 감지한 학습데이터 수%1',
              CodeWizLite_HuskyLens_isContainHuskyLens: '허스키렌즈 ID:%1로 인식한 %2데이터가 있는가?%3',
              CodeWizLite_HuskyLens_hasTypeHuskyLens: '허스키렌즈가 읽은 데이터 타입이%1인가?%2',
              CodeWizLite_HuskyLens_getArrowInfoHuskyLens: '허스키렌즈가 읽은 ID%1인 화살표정보%2%3',
              CodeWizLite_HuskyLens_getBoxInfoHuskyLens2: '허스키렌즈가 읽은 ID%1인 사각형정보%2%3',
              CodeWizLite_HuskyLens_getBoxInfoHuskyLens: '허스키렌즈가 읽은 사각형정보%1(중심좌표가 중앙에 가장 가까운 것)%2',
              CodeWizLite_HuskyLens_writeTextHuskyLens: '허스키렌즈 (%1,%2)에 %3출력%4',
              CodeWizLite_HuskyLens_clearTextHuskyLens: '허스키렌즈 텍스트 지우기%1',
              CodeWizLite_Servo_title: '서보모터',
              CodeWizLite_Servo_setAngle: '서보모터(%1) 각도를 %2(으)로 바꾸기%3',
              CodeWizLite_Servo_menuSpeed: '무한회전 서보모터(%1) %2속도로 정하기%3',
              CodeWizLite_Servo_customSpeed: '무한회전 서보모터(%1) %2속도로 정하기(-100~100)%3',
              CodeWizLite_Dc_title: 'DC 모터',
              CodeWizLite_Dc_setCarSpeed: 'WizCar모터에 왼쪽%1, 오른쪽%2 내보내기(-1000~1000)%3',
              CodeWizLite_Dc_setValue_Waterpump: '워터펌프(%1)에 %2내보내기(0~1023)%3',
              CodeWizLite_DotMatrix_title: '도트매트릭스',
              CodeWizLite_DotMatrix_init: '도트매트릭스 %1개 DIN%2, CS%3, CLK%4로 설정%5',
              CodeWizLite_DotMatrix_setBrightness: '도트매트릭스 %1번 밝기를 %2(으)로 설정%3',
              CodeWizLite_DotMatrix_printString: '도트매트릭스 %1번에 문자열%2 출력%3',
              CodeWizLite_DotMatrix_setLine: '도트매트릭스 %1번의 %2%3 %4(으)로 만들기%5',
              // CodeWizLite_DotMatrix_Show_Custom_Image:
              //     '도트매트릭스 %1번에 LED %2 켜기 %3',
              CodeWizLite_DotMatrix_setDot: '도트매트릭스 %1번의 %2행%3열 %4%5',
              CodeWizLite_DotMatrix_clear: '도트매트릭스 %1번 지우기%2',
              CodeWizLite_DotMatrix_clearAll: '도트매트릭스 모두 지우기%1',
              CodeWizLite_ColorSensor_title: '컬러센서',
              CodeWizLite_ColorSensor_isColor: 'MCON 컬러센서 감지된 색이 %1인가%2',
              CodeWizLite_ColorSensor_getColorValue: 'MCON 컬러센서 %1값%2',
              CodeWizLite_DHT_title: '디지털 온습도',
              CodeWizLite_DHT_init: '디지털 온습도 pin%1에 설정%2',
              CodeWizLite_DHT_getValue: '디지털 온습도 %1값%2',
              CodeWizLite_Joystick_title: '조이스틱',
              CodeWizLite_Joystick_setPin: '조이스틱 설정하기(X축%1, Y축%2, 버튼%3, 범위%4)%5',
              CodeWizLite_Joystick_readAxis: '조이스틱 %1의 값%2',
              CodeWizLite_Joystick_readButton: '조이스틱 버튼 값%1',
              CodeWizLite_etcReadSensor_title: '기타 입력센서',
              CodeWizLite_etcReadSensor_mconRead: 'MCON%1(pin%2)의 측정값%3',
              CodeWizLite_etcReadSensor_digitalRead: '%1(pin%2)의 측정값%3',
              CodeWizLite_etcReadSensor_InfraredThermometerRead: '비접촉온도센서 %1에 %2로 읽기%3'
            },
            Helper: {
              CodeWizLite_get_sensor: "\uC8FC\uBCC0\uC758 \uC18C\uB9AC\uAC12\uC744 0~1023 \uC0AC\uC774 \uAC12\uC73C\uB85C \uC54C\uB824\uC90D\uB2C8\uB2E4.\n        \n                        \u25BC\uC744 \uD074\uB9AD\uD558\uC5EC \uBE5B, \uAC70\uB9AC, \uD640, \uC628\uB3C4\uB97C \uC120\uD0DD\uD558\uC5EC\n                        \uC8FC\uBCC0\uC758 \uBC1D\uAE30, \uAC70\uB9AC, \uC790\uC131, \uBCF4\uB4DC\uC758 \uC628\uB3C4\uB97C \uD655\uC778\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
              CodeWizLite_get_gyroSensor: "\uC120\uD0DD\uB41C \uCD95\uC758 \uAE30\uC6B8\uAE30\uB97C -90~90 \uC0AC\uC774 \uAC12\uC73C\uB85C \uC54C\uB824\uC90D\uB2C8\uB2E4.\n                        \u25BC\uC744 \uB20C\uB7EC X\uCD95, Y\uCD95, Z\uCD95\uC744 \uC120\uD0DD\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
              CodeWizLite_isPushedButton: "\uC67C\uCABD/\uC624\uB978\uCABD \uBC84\uD2BC\uC744 \uB204\uB974\uBA74 \u201C\uCC38\u201D \uC73C\uB85C \uD310\uB2E8\uD569\uB2C8\uB2E4.\n                        \u25BC\uC744 \uB20C\uB7EC \uC67C\uCABD, \uC624\uB978\uCABD\uC744 \uC120\uD0DD\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
              CodeWizLite_touchPin: "\uD83D\uDC3B \uBAA8\uC591\uC758 \uD130\uCE58\uC13C\uC11C\uB97C \uC190\uAC00\uB77D\uC73C\uB85C \uD130\uCE58\uD558\uBA74 \u201C\uCC38\u201C\uC73C\uB85C \uD310\uB2E8\uD569\uB2C8\uB2E4.\n                        \u25BC\uC744 \uB20C\uB7EC \uD83D\uDD06,\u2B55, \uD83D\uDD90, \uD83D\uDC4A, \u274C \uBAA8\uC591\uC758 \uD130\uCE58\uC13C\uC11C\uB97C \uC120\uD0DD\uD558\uBA74 \uD574\uB2F9 \uBAA8\uC591\uC758 \uD130\uCE58\uC13C\uC11C\uC758 \uD130\uCE58 \uC5EC\uBD80\uB3C4 \uD655\uC778\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
              CodeWizLite_default_buzzer: "\uC9C0\uC815\uB41C \uC625\uD0C0\uBE0C\uC758 \uC74C\uC744 \uC9C0\uC815\uB41C \uC74C\uD45C\uB85C \uC2A4\uD53C\uCEE4(\uBD80\uC800)\uB97C \uC7AC\uC0DD\uD569\uB2C8\uB2E4.",
              CodeWizLite_neopixel_init: "\uCF54\uB4DC\uC704\uC988\uC758 \uB124\uC624 RGB LED 5\uAC1C\uC758 \uC0AC\uC6A9\uC744 \uC124\uC815\uD569\uB2C8\uB2E4.\n                        \u25BC\uC744 \uB20C\uB7EC SCON\uC5D0 \uC5F0\uACB0\uB41C \uB124\uC624\uD53D\uC140\uC758 \uAC1C\uC218\uC640 \uC0AC\uC6A9\uC744 \uC124\uC815\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
              CodeWizLite_neopixel_brightness: "\uBC1D\uAE30\uB97C 0~255 \uC0AC\uC774 \uAC12\uC73C\uB85C \uC9C0\uC815\uD569\uB2C8\uB2E4.",
              CodeWizLite_neopixel_setColor_one: "\uC785\uB825\uD55C \uBC88\uD638\uC758 LED\uB97C \uC120\uD0DD\uD55C \uC0C9\uC73C\uB85C \uCF2D\uB2C8\uB2E4.",
              CodeWizLite_neopixel_setColor_one2: "\uC785\uB825\uD55C \uBC88\uD638\uC758 LED\uB97C \uBE68\uAC15, \uCD08\uB85D, \uD30C\uB791\uC5D0 \uC785\uB825\uB41C \uAC12\uC758 \uC0C9\uC73C\uB85C \uCF2D\uB2C8\uB2E4.\n                            \uAC01 \uAC12\uC744 0~255 \uC0AC\uC774 \uAC12\uC73C\uB85C \uC9C0\uC815\uD569\uB2C8\uB2E4.",
              CodeWizLite_neopixel_off_one: "\uC785\uB825\uD55C \uBC88\uD638\uC758 LED\uB97C \uB055\uB2C8\uB2E4.",
              CodeWizLite_neopixel_setColor_all: "\uBAA8\uB4E0 LED\uB97C \uC120\uD0DD\uD55C \uC0C9\uC73C\uB85C \uCF2D\uB2C8\uB2E4.",
              CodeWizLite_neopixel_setColor_all2: "\uBAA8\uB4E0 LED\uB97C \uBE68\uAC15, \uCD08\uB85D, \uD30C\uB791\uC5D0 \uC785\uB825\uB41C \uAC12\uC758 \uC0C9\uC73C\uB85C \uCF2D\uB2C8\uB2E4.\n                        \uAC01 \uAC12\uC744 0~255 \uC0AC\uC774 \uAC12\uC73C\uB85C \uC9C0\uC815\uD569\uB2C8\uB2E4.",
              CodeWizLite_neopixel_off_all: "\uBAA8\uB4E0 LED\uB97C \uB055\uB2C8\uB2E4.",
              CodeWizLite_neopixel_OnPixelRandomColor: "\uC785\uB825\uD55C \uBC88\uD638\uC758 LED\uB97C \uBB34\uC791\uC704 \uC0C9\uC73C\uB85C \uCF2D\uB2C8\uB2E4.",
              CodeWizLite_neopixel_fillRandom: "\uBAA8\uB4E0 LED\uB97C \uBB34\uC791\uC704 \uC0C9\uC73C\uB85C \uCC44\uC6C1\uB2C8\uB2E4.",
              CodeWizLite_neopixel_rotate: "\uBAA8\uB4E0 LED\uB97C \uC9C0\uC815\uD55C \uBC29\uD5A5\uC73C\uB85C \uD68C\uC804\uC2DC\uD0B5\uB2C8\uB2E4.\n                        \uBC29\uD5A5\uC740 \u25BC\uC744 \uB20C\uB7EC \uC124\uC815\uD569\uB2C8\uB2E4.",
              CodeWizLite_neopixel_shift: "\uBAA8\uB4E0 LED\uB97C \uC9C0\uC815\uD55C \uBC29\uD5A5\uC73C\uB85C \uBC00\uC5B4\uB0C5\uB2C8\uB2E4.\n                        \uBE48\uC790\uB9AC\uB294 \uAE30\uC874 \uC0C9\uC73C\uB85C \uCC44\uC6CC\uC9D1\uB2C8\uB2E4.\n                        \uBC29\uD5A5\uC740 \u25BC\uC744 \uB20C\uB7EC \uC124\uC815\uD569\uB2C8\uB2E4.",
              CodeWizLite_neopixel_gradationRGB: "\uC9C0\uC815\uBC94\uC704\uC758 LED\uB97C \uC120\uD0DD\uD55C \uC0C9\uC758 \uADF8\uB77C\uB370\uC774\uC158\uC73C\uB85C \uCC44\uC6C1\uB2C8\uB2E4.\n                        \uC67C\uCABD\uC0C9\uBD80\uD130 \uC624\uB978\uCABD\uC0C9\uAE4C\uC9C0 RGB\uC0C9\uD45C\uD604\uC758 \uADF8\uB77C\uB370\uC774\uC158\uC73C\uB85C \uCC44\uC6CC\uC9D1\uB2C8\uB2E4.\n                        \uBC94\uC704\uB294 \uCD08\uAE30\uD654\uD55C LED\uBC94\uC704\uB97C \uBC97\uC5B4\uB0A0 \uC218 \uC5C6\uC73C\uBA70 \uC11C\uB85C \uB2E4\uB978 \uAC12\uC774\uC5EC\uC57C \uD569\uB2C8\uB2E4.\n                        LED \uBC88\uD638\uAC00 \uC791\uC740 \uAC12\uC740 \uC67C\uCABD\uC5D0 \uD070 \uAC12\uC740 \uC624\uB978\uCABD\uC5D0 \uC704\uCE58\uD574\uC57C\uD569\uB2C8\uB2E4.",
              CodeWizLite_neopixel_gradationHSL: "\uC9C0\uC815\uBC94\uC704\uC758 LED\uB97C \uC120\uD0DD\uD55C \uC0C9\uC758 \uADF8\uB77C\uB370\uC774\uC158\uC73C\uB85C \uCC44\uC6C1\uB2C8\uB2E4.\n                        \uC67C\uCABD\uC0C9\uBD80\uD130 \uC624\uB978\uCABD\uC0C9\uAE4C\uC9C0 HSL\uC0C9\uD45C\uD604\uC758 \uADF8\uB77C\uB370\uC774\uC158\uC73C\uB85C \uCC44\uC6CC\uC9D1\uB2C8\uB2E4.\n                        \uBC94\uC704\uB294 \uCD08\uAE30\uD654\uD55C LED\uBC94\uC704\uB97C \uBC97\uC5B4\uB0A0 \uC218 \uC5C6\uC73C\uBA70 \uC11C\uB85C \uB2E4\uB978 \uAC12\uC774\uC5EC\uC57C \uD569\uB2C8\uB2E4.\n                        LED \uBC88\uD638\uAC00 \uC791\uC740 \uAC12\uC740 \uC67C\uCABD\uC5D0 \uD070 \uAC12\uC740 \uC624\uB978\uCABD\uC5D0 \uC704\uCE58\uD574\uC57C\uD569\uB2C8\uB2E4.",
              CodeWizLite_neopixel_wheeeeeeel: "\uB179\uC0C9, \uBE68\uAC15, \uD30C\uB791\uC758 \uC138 \uAC00\uC9C0\uC0C9\uC744 \uAE30\uC900\uC73C\uB85C \uC11E\uC740 \uC0C9\uC744 \uC21C\uD658\uC2DC\uCF1C \uCF1C\uC8FC\uB294 \uBE14\uB85D\uC785\uB2C8\uB2E4.\n                        \uC774 \uBE14\uB85D\uC744 \uC0AC\uC6A9\uD574\uC11C \uD750\uB974\uB294 \uB4EF\uD55C \uB124\uC624\uD53D\uC140\uC744 \uD45C\uC2DC\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
              CodeWizLite_OLED_clear: "OLED\uC5D0 \uD45C\uC2DC\uB41C \uB0B4\uC6A9\uC744 \uC9C0\uC6C1\uB2C8\uB2E4.",
              CodeWizLite_OLED_mirror: "OLED\uC5D0 \uD45C\uC2DC\uD560 \uB0B4\uC6A9\uC758 \uCD9C\uB825 \uC0C1\uD0DC\uB97C \uC124\uC815\uD569\uB2C8\uB2E4.\n                        OFF\uAC00 \uAE30\uBCF8\uC774\uBA70, ON\uC744 \uC120\uD0DD\uD558\uBA74 OLED \uBC30\uACBD\uC5D0 \uC0C9\uC774 \uCC44\uC6CC\uC9C0\uACE0 \uB0B4\uC6A9\uC774 \uD45C\uC2DC\uB429\uB2C8\uB2E4.",
              CodeWizLite_OLED_setSize: "\uAE00\uC790 \uD06C\uAE30\uB97C \uC9C0\uC815\uD569\uB2C8\uB2E4.\n                        1~10 \uC0AC\uC774\uC758 \uBC94\uC704\uB85C \uC124\uC815\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
              CodeWizLite_OLED_setPosition: "\uAE00\uC790\uAC00 \uCD9C\uB825\uB420 \uC704\uCE58(x\uC88C\uD45C, y\uC88C\uD45C)\uB97C \uC9C0\uC815\uD569\uB2C8\uB2E4.\n                        X\uB294 0~127, Y\uB294 0~63 \uC0AC\uC774\uC758 \uBC94\uC704\uB85C \uC124\uC815\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
              CodeWizLite_OLED_println: "\uC785\uB825\uD55C \uB0B4\uC6A9\uC744 OLED\uC5D0 \uCD9C\uB825\uD569\uB2C8\uB2E4.",
              CodeWizLite_OLED_isCollision: "OLED\uC5D0 \uCD9C\uB825\uB41C \uB0B4\uC6A9\uC758 \uC904\uBC14\uAFC8\uC744 \uC124\uC815\uD569\uB2C8\uB2E4.",
              CodeWizLite_OLED_specialChar: "OLED\uC5D0 \uAE30\uD638\uB97C \uCD9C\uB825\uD569\uB2C8\uB2E4.",
              CodeWizLite_OLED_setFont: "\uAE00\uAF34\uACFC \uAE00\uC790 \uD06C\uAE30\uB97C \u25BC \uC744 \uB20C\uB7EC \uC124\uC815\uD569\uB2C8\uB2E4.",
              CodeWizLite_OLED_startScroll: "OLED\uC5D0 \uC785\uB825\uB41C \uB0B4\uC6A9\uC744 \uC9C0\uC815\uD55C \uD654\uC0B4\uD45C\uBC29\uD5A5\uC73C\uB85C \uC774\uB3D9\uC2DC\uD0B5\uB2C8\uB2E4. \uC2DC\uC791\uACFC \uC885\uB8CC\uB294 y\uC88C\uD45C\uB97C 0~7 \uD398\uC774\uC9C0\uB85C \uB098\uB208 \uAC83\uC73C\uB85C \uAC01 \uD398\uC774\uC9C0\uB294 \uB2E4\uC74C\uACFC \uAC19\uC740 y \uC88C\uD45C\uB97C \uAC00\uC9D1\uB2C8\uB2E4.\n                        \n                        0 : y\uC88C\uD45C 0~7\n                        1 : y\uC88C\uD45C 8~15\n                        2 : y\uC88C\uD45C 16~23\n                        3 : y\uC88C\uD45C 24~31\n                        4 : y\uC88C\uD45C 32~39\n                        5 : y\uC88C\uD45C 40~47\n                        6 : y\uC88C\uD45C 48~55\n                        7 : y\uC88C\uD45C 56~63",
              CodeWizLite_OLED_stopScroll: "\uC774\uB3D9\uC744 \uBA48\uCDA5\uB2C8\uB2E4.",
              CodeWizLite_OLED_drawPoint: "\uC9C0\uC815\uB41C \uC704\uCE58 (x\uC88C\uD45C, y\uC88C\uD45C)\uC5D0 \uC810\uC744 \uCC0D\uC2B5\uB2C8\uB2E4.\n                        X\uB294 0~127, Y\uB294 0~63 \uC0AC\uC774\uC758 \uBC94\uC704\uB85C \uC124\uC815\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
              CodeWizLite_OLED_drawLine1: "\uC2DC\uC791 \uC704\uCE58 (x\uC88C\uD45C, y\uC88C\uD45C)\uC5D0\uC11C \uB05D \uC704\uCE58 (x\uC88C\uD45C, y\uC88C\uD45C)\uAE4C\uC9C0 \uD770\uC0C9 \uC120\uC744 \uADF8\uB9BD\uB2C8\uB2E4.",
              CodeWizLite_OLED_drawLine2: "\uC2DC\uC791 \uC704\uCE58 (x\uC88C\uD45C, y\uC88C\uD45C)\uC5D0\uC11C \uC9C0\uC815\uB41C \uAE38\uC774\uC758 \uD770\uC0C9 \uC218\uC9C1\uC120\uC744 \uADF8\uB9BD\uB2C8\uB2E4.",
              CodeWizLite_OLED_drawLine3: "\uC2DC\uC791 \uC704\uCE58 (x\uC88C\uD45C, y\uC88C\uD45C)\uC5D0\uC11C \uC9C0\uC815\uB41C \uAE38\uC774\uC758 \uD770\uC0C9 \uC218\uD3C9\uC120\uC744 \uADF8\uB9BD\uB2C8\uB2E4.",
              CodeWizLite_OLED_drawRect: "\uC2DC\uC791 \uC704\uCE58 (x\uC88C\uD45C, y\uC88C\uD45C)\uC5D0\uC11C \uC9C0\uC815\uB41C \uAC00\uB85C, \uC138\uB85C \uAE38\uC774\uC758 \uD770\uC0C9 \uC120 \uC9C1\uC0AC\uAC01\uD615\uC744 \uADF8\uB9BD\uB2C8\uB2E4.\n                        \u25BC\uC744 \uB20C\uB7EC \u2018\uBE44\uC6C0\u2019 \uB300\uC2E0 \u2018\uCC44\uC6C0\u2018\uC744 \uC120\uD0DD\uD558\uBA74 \uC9C1\uC0AC\uAC01\uD615 \uB0B4\uBD80\uAC00 \uCC44\uC6CC\uC9D1\uB2C8\uB2E4.",
              CodeWizLite_OLED_drawCircle: "\uC911\uC2EC(x\uC88C\uD45C, y\uC88C\uD45C)\uC5D0\uC11C \uC9C0\uC815\uB41C \uBC18\uC9C0\uB984\uC744 \uAC00\uC9C0\uB294 \uD770\uC0C9 \uC120 \uC6D0\uC744 \uADF8\uB9BD\uB2C8\uB2E4.\n                        \u25BC\uC744 \uB20C\uB7EC \u2018\uBE44\uC6C0\u2019 \uB300\uC2E0 \u2018\uCC44\uC6C0\u2018\uC744 \uC120\uD0DD\uD558\uBA74 \uC6D0 \uB0B4\uBD80\uAC00 \uCC44\uC6CC\uC9D1\uB2C8\uB2E4.",
              CodeWizLite_OLED_drawPoligon: "\uC8101(x\uC88C\uD45C, y\uC88C\uD45C), \uC8102 (x\uC88C\uD45C, y\uC88C\uD45C), \uC8103 (x\uC88C\uD45C, y\uC88C\uD45C)\uC744 \uC5F0\uACB0\uD558\uC5EC \uD770\uC0C9 \uC120 \uC0BC\uAC01\uD615\uC744 \uADF8\uB9BD\uB2C8\uB2E4.\n                        \u25BC\uC744 \uB20C\uB7EC \u2018\uBE44\uC6C0\u2019 \uB300\uC2E0 \u2018\uCC44\uC6C0\u2018\uC744 \uC120\uD0DD\uD558\uBA74 \uC6D0 \uB0B4\uBD80\uAC00 \uCC44\uC6CC\uC9D1\uB2C8\uB2E4.",
              CodeWizLite_OLED_printHG: "\uC785\uB825\uD55C \uB0B4\uC6A9(\uD55C\uAE00\uD3EC\uD568)\uC744 OLED\uC5D0 \uCD9C\uB825\uD569\uB2C8\uB2E4.\n                        \u25BC\uC744 \uB20C\uB7EC \u2018\u2B55\u2019\uB97C \uC120\uD0DD\uD558\uBA74 \uC544\uB7AB\uC904\uB85C \uCEE4\uC11C\uB97C \uC774\uB3D9\uC2DC\uD0A4\uACE0 \u2018\u274C\u2018\uB97C \uC120\uD0DD\uD558\uBA74 \uB9C8\uC9C0\uB9C9 \uAE00\uC790 \uC624\uB978\uCABD\uC73C\uB85C \uCEE4\uC11C\uB97C \uC774\uB3D9\uC2DC\uD0B5\uB2C8\uB2E4.",
              CodeWizLite_DIGITAL_OUTPUT_digitalWrite: "\uC9C0\uC815\uB41C \uD540(\uD130\uCE58\uC13C\uC11C \uB610\uB294 SCON)\uC5D0 \uC5F0\uACB0\uB41C \uC13C\uC11C\uB85C HIGH \uB610\uB294 LOW \uB97C \uB0B4\uBCF4\uB0C5\uB2C8\uB2E4.\n                        \n                        <\uD604\uC7AC \uD65C\uC6A9 \uAC00\uB2A5\uD55C \uD655\uC7A5\uB3C4\uAD6C>\n                        \uC9C4\uB3D9\uBAA8\uD130",
              CodeWizLite_DIGITAL_OUTPUT_pwmWrite: "\uC9C0\uC815\uB41C \uD540(\uD130\uCE58\uC13C\uC11C \uB610\uB294 SCON)\uC5D0 \uC5F0\uACB0\uB41C \uC13C\uC11C\uB85C \uC785\uB825\uB41C \uAC12\uC744 \uB0B4\uBCF4\uB0C5\uB2C8\uB2E4.\n                        \n                        <\uD604\uC7AC \uD65C\uC6A9 \uAC00\uB2A5\uD55C \uD655\uC7A5\uB3C4\uAD6C>\n                        \uD504\uB85C\uD3A0\uB7EC",
              CodeWizLite_OzEye_initOzEye: "\uC624\uC988\uC544\uC774 \uC2DC\uC791\uC744 \uC124\uC815\uD569\uB2C8\uB2E4.",
              CodeWizLite_OzEye_setModeOfOzEye: "\uC624\uC988\uC544\uC774\uB97C \uC120\uD0DD\uB41C \uC54C\uACE0\uB9AC\uC998\uC73C\uB85C \uC124\uC815\uD569\uB2C8\uB2E4.\n        \n                        1.\uC120 \uC778\uC2DD\n                        2.\uC0C9 \uC778\uC2DD\n                        3.\uD0DC\uADF8 \uC778\uC2DD\n                        4.\uC774\uBBF8\uC9C0 \uC778\uC2DD\n                        5.\uC0AC\uBB3C \uC778\uC2DD\n                        6.\uC0AC\uBB3C \uCD94\uC801\n                        7.\uC120 + \uD0DC\uADF8\n                        8.\uC5BC\uAD74 \uC778\uC2DD\n                        9.\uC22B\uC790 \uC778\uC2DD",
              Eye_readOzEye: "\uC624\uC988\uC544\uC774\uAC00 \uC778\uC2DD\uD55C \uACB0\uACFC\uB97C \uC8FC\uAE30\uC801\uC73C\uB85C \uBCF4\uB0B4\uC90D\uB2C8\uB2E4.",
              CodeWizLite_OzEye_isLearnedOzEye: "\uC785\uB825\uD55C ID \uBC88\uD638 \uB370\uC774\uD130\uB97C \uD559\uC2B5\uD588\uB2E4\uBA74 \u2018\uCC38\u2019\uC73C\uB85C \uD310\uB2E8\uD558\uC5EC \uC54C\uB824\uC90D\uB2C8\uB2E4.",
              CodeWizLite_OzEye_isContainOzEye: "\uC785\uB825\uD55C ID \uBC88\uD638\uC758 \uC0AC\uAC01\uD615 \uB370\uC774\uD130\uAC00 \uC778\uC2DD\uB41C\uB2E4\uBA74 \u2018\uCC38\u2019\uC73C\uB85C \uD310\uB2E8\uD558\uC5EC \uC54C\uB824\uC90D\uB2C8\uB2E4.\n                            \u25BC\uC744 \uB20C\uB7EC \uD654\uC0B4\uD45C\uB97C \uC120\uD0DD\uD558\uBA74 \uD654\uC0B4\uD45C \uB370\uC774\uD130\uAC00 \uC778\uC2DD\uB420 \uB54C \u2018\uCC38\u2019\uC73C\uB85C \uD310\uB2E8\uD558\uC5EC \uC54C\uB824\uC90D\uB2C8\uB2E4.",
              CodeWizLite_OzEye_getCountLearnedOzEye: "\uD654\uBA74\uC5D0 \uAC10\uC9C0\uB41C \uD559\uC2B5\uD55C \uB370\uC774\uD130 \uC218\uB97C \uC54C\uB824\uC90D\uB2C8\uB2E4.",
              CodeWizLite_OzEye_hasTypeOzEye: "\uC77D\uC5B4\uC628 \uB370\uC774\uD130 \uD0C0\uC785\uC774 \uC120\uD0DD\uD55C \uD0C0\uC785(\uC0AC\uAC01\uD615/\uD654\uC0B4\uD45C)\uACFC \uAC19\uB2E4\uBA74 \u2018\uCC38\u2019\uC73C\uB85C \uD310\uB2E8\uD558\uC5EC \uC54C\uB824\uC90D\uB2C8\uB2E4.",
              CodeWizLite_OzEye_getArrowInfoOzEye: "\uC77D\uC5B4\uC628 \uD654\uC0B4\uD45C \uB370\uC774\uD130\uC758 \uC88C\uD45C \uAC12\uC744 \uC54C\uB824\uC90D\uB2C8\uB2E4. \uC88C\uD45C \uAC12\uC740 \u2018\uC2DC\uC791 X\uC88C\uD45C\u2018, \u2018\uC2DC\uC791 Y\uC88C\uD45C\u2018, \u2018\uC885\uB8CC X\uC88C\uD45C\u2018, \u2018\uC885\uB8CC Y\uC88C\uD45C\u2018 \uC911 \uD558\uB098\uB97C \uC120\uD0DD\uD569\uB2C8\uB2E4.\n                            \uB300\uC0C1\uC774 \uC5C6\uB2E4\uBA74 -1\uC744 \uBC18\uD658\uD569\uB2C8\uB2E4.",
              CodeWizLite_OzEye_getBoxInfoOzEye2: "\uC77D\uC5B4\uC628 \uC0AC\uAC01\uD615 \uB370\uC774\uD130\uC758 \uC815\uBCF4\uB97C \uC54C\uB824\uC90D\uB2C8\uB2E4. \uC815\uBCF4\uB294 \u2018\uC911\uC2EC X\uC88C\uD45C\u2018, \u2018\uC911\uC2EC Y\uC88C\uD45C\u2019, \u2018\uB108\uBE44\u2018, \u2018\uB192\uC774\u2019 \uC911 \uD558\uB098\uB97C \uC120\uD0DD\uD569\uB2C8\uB2E4.\n                            \uB300\uC0C1\uC774 \uC5C6\uB2E4\uBA74 -1\uC744 \uBC18\uD658\uD569\uB2C8\uB2E4.",
              CodeWizLite_OzEye_getBoxInfoOzEye: "\uC77D\uC5B4\uC628 \uC0AC\uAC01\uD615 \uB370\uC774\uD130\uC758 \uC815\uBCF4\uB97C \uC54C\uB824\uC90D\uB2C8\uB2E4. \uC815\uBCF4\uB294 \u2018ID\u2019, \u2018\uC911\uC2EC X\uC88C\uD45C\u2018, \u2018\uC911\uC2EC Y\uC88C\uD45C\u2019, \u2018\uB108\uBE44\u2018, \u2018\uB192\uC774\u2019 \uC911 \uD558\uB098\uB97C \uC120\uD0DD\uD569\uB2C8\uB2E4.\n                            \uB300\uC0C1\uC774 \uC5C6\uB2E4\uBA74 -1\uC744 \uBC18\uD658\uD569\uB2C8\uB2E4.",
              // CodeWizLite_OzEye_writeTextOzEye: `오즈아이 화면의 지정된 좌표에 입력된 데이터를 출력합니다.`,
              // CodeWizLite_OzEye_clearTextOzEye: `오즈아이 화면에 출력되어 있는 데이터를 지웁니다.`,
              CodeWizLite_OzEye_setLightLevel: '오즈아이의 라이트 밝기를 1~7 단계로 설정합니다.',
              CodeWizLite_OzEye_LightOff: '오즈아이 라이트를 끕니다.',
              CodeWizLite_HuskyLens_initHuskyLens: "\uD5C8\uC2A4\uD0A4\uB80C\uC988 \uC2DC\uC791\uC744 \uC124\uC815\uD569\uB2C8\uB2E4.",
              CodeWizLite_HuskyLens_setModeOfHuskyLens: "\uD5C8\uC2A4\uD0A4\uB80C\uC988\uB97C \uC120\uD0DD\uB41C \uC54C\uACE0\uB9AC\uC998\uC73C\uB85C \uC124\uC815\uD569\uB2C8\uB2E4.\n        \n                        1.FACE_RECOGNITION\n                        2.OBJECT_TRACKING\n                        3.OBJECT_RECOGNITION\n                        4.LINE_TRACKING\n                        5.COLOR_RECOGNITION\n                        6.TAG_RECOGNITION\n                        7.OBJECT_CLASSIFICATION",
              CodeWizLite_HuskyLens_readHuskyLens: "\uD5C8\uC2A4\uD0A4\uB80C\uC988\uAC00 \uC778\uC2DD\uD55C \uACB0\uACFC\uB97C \uC8FC\uAE30\uC801\uC73C\uB85C \uBCF4\uB0B4\uC90D\uB2C8\uB2E4.",
              CodeWizLite_HuskyLens_isLearnedHuskyLens: "\uC785\uB825\uD55C ID \uBC88\uD638 \uB370\uC774\uD130\uB97C \uD559\uC2B5\uD588\uB2E4\uBA74 \u2018\uCC38\u2019\uC73C\uB85C \uD310\uB2E8\uD558\uC5EC \uC54C\uB824\uC90D\uB2C8\uB2E4.",
              CodeWizLite_HuskyLens_isContainHuskyLens: "\uC785\uB825\uD55C ID \uBC88\uD638\uC758 \uC0AC\uAC01\uD615 \uB370\uC774\uD130\uAC00 \uC778\uC2DD\uB41C\uB2E4\uBA74 \u2018\uCC38\u2019\uC73C\uB85C \uD310\uB2E8\uD558\uC5EC \uC54C\uB824\uC90D\uB2C8\uB2E4.\n                            \u25BC\uC744 \uB20C\uB7EC \uD654\uC0B4\uD45C\uB97C \uC120\uD0DD\uD558\uBA74 \uD654\uC0B4\uD45C \uB370\uC774\uD130\uAC00 \uC778\uC2DD\uB420 \uB54C \u2018\uCC38\u2019\uC73C\uB85C \uD310\uB2E8\uD558\uC5EC \uC54C\uB824\uC90D\uB2C8\uB2E4.",
              CodeWizLite_HuskyLens_getCountLearnedHuskyLens: "\uD654\uBA74\uC5D0 \uAC10\uC9C0\uB41C \uD559\uC2B5\uD55C \uB370\uC774\uD130 \uC218\uB97C \uC54C\uB824\uC90D\uB2C8\uB2E4.",
              CodeWizLite_HuskyLens_hasTypeHuskyLens: "\uC77D\uC5B4\uC628 \uB370\uC774\uD130 \uD0C0\uC785\uC774 \uC120\uD0DD\uD55C \uD0C0\uC785(\uC0AC\uAC01\uD615/\uD654\uC0B4\uD45C)\uACFC \uAC19\uB2E4\uBA74 \u2018\uCC38\u2019\uC73C\uB85C \uD310\uB2E8\uD558\uC5EC \uC54C\uB824\uC90D\uB2C8\uB2E4.",
              CodeWizLite_HuskyLens_getArrowInfoHuskyLens: "\uC77D\uC5B4\uC628 \uD654\uC0B4\uD45C \uB370\uC774\uD130\uC758 \uC88C\uD45C \uAC12\uC744 \uC54C\uB824\uC90D\uB2C8\uB2E4. \uC88C\uD45C \uAC12\uC740 \u2018\uC2DC\uC791 X\uC88C\uD45C\u2018, \u2018\uC2DC\uC791 Y\uC88C\uD45C\u2018, \u2018\uC885\uB8CC X\uC88C\uD45C\u2018, \u2018\uC885\uB8CC Y\uC88C\uD45C\u2018 \uC911 \uD558\uB098\uB97C \uC120\uD0DD\uD569\uB2C8\uB2E4.\n                            \uB300\uC0C1\uC774 \uC5C6\uB2E4\uBA74 -1\uC744 \uBC18\uD658\uD569\uB2C8\uB2E4.",
              CodeWizLite_HuskyLens_getBoxInfoHuskyLens2: "\uC77D\uC5B4\uC628 \uC0AC\uAC01\uD615 \uB370\uC774\uD130\uC758 \uC815\uBCF4\uB97C \uC54C\uB824\uC90D\uB2C8\uB2E4. \uC815\uBCF4\uB294 \u2018\uC911\uC2EC X\uC88C\uD45C\u2018, \u2018\uC911\uC2EC Y\uC88C\uD45C\u2019, \u2018\uB108\uBE44\u2018, \u2018\uB192\uC774\u2019 \uC911 \uD558\uB098\uB97C \uC120\uD0DD\uD569\uB2C8\uB2E4.\n                            \uB300\uC0C1\uC774 \uC5C6\uB2E4\uBA74 -1\uC744 \uBC18\uD658\uD569\uB2C8\uB2E4.",
              CodeWizLite_HuskyLens_getBoxInfoHuskyLens: "\uC77D\uC5B4\uC628 \uC0AC\uAC01\uD615 \uB370\uC774\uD130\uC758 \uC815\uBCF4\uB97C \uC54C\uB824\uC90D\uB2C8\uB2E4. \uC815\uBCF4\uB294 \u2018ID\u2019, \u2018\uC911\uC2EC X\uC88C\uD45C\u2018, \u2018\uC911\uC2EC Y\uC88C\uD45C\u2019, \u2018\uB108\uBE44\u2018, \u2018\uB192\uC774\u2019 \uC911 \uD558\uB098\uB97C \uC120\uD0DD\uD569\uB2C8\uB2E4.\n                            \uB300\uC0C1\uC774 \uC5C6\uB2E4\uBA74 -1\uC744 \uBC18\uD658\uD569\uB2C8\uB2E4.",
              CodeWizLite_HuskyLens_writeTextHuskyLens: "\uD5C8\uC2A4\uD0A4\uB80C\uC988 \uD654\uBA74\uC758 \uC9C0\uC815\uB41C \uC88C\uD45C\uC5D0 \uC785\uB825\uB41C \uB370\uC774\uD130\uB97C \uCD9C\uB825\uD569\uB2C8\uB2E4.",
              CodeWizLite_HuskyLens_clearTextHuskyLens: "\uD5C8\uC2A4\uD0A4\uB80C\uC988 \uD654\uBA74\uC5D0 \uCD9C\uB825\uB418\uC5B4 \uC788\uB294 \uB370\uC774\uD130\uB97C \uC9C0\uC6C1\uB2C8\uB2E4.",
              CodeWizLite_Servo_setAngle: "\uC120\uD0DD\uB41C \uCEE4\uB125\uD130(MCON/SCON)\uC5D0 \uC5F0\uACB0\uB41C 180\uB3C4 \uC11C\uBCF4\uBAA8\uD130\uC758 \uAC01\uB3C4\uB97C \uC785\uB825\uB41C \uAC01\uB3C4\uB85C \uD68C\uC804\uC2DC\uD0B5\uB2C8\uB2E4.(0~180)",
              CodeWizLite_Servo_menuSpeed: "\uC120\uD0DD\uB41C \uCEE4\uB125\uD130(MCON/SCON)\uC5D0 \uBB34\uD55C\uD68C\uC804 \uC11C\uBCF4\uBAA8\uD130\uB97C \uC9C0\uC815\uB41C \uC18D\uB3C4\uB85C \uD68C\uC804\uC2DC\uD0B5\uB2C8\uB2E4.\n                        \u25BC\uC744 \uB20C\uB7EC \uC18D\uB3C4\uB97C \uC120\uD0DD\uD569\uB2C8\uB2E4.(\uBE60\uB978/\uBCF4\uD1B5/\uB290\uB9BC/\uBA48\uCD98)",
              CodeWizLite_Servo_customSpeed: "\uC120\uD0DD\uB41C \uCEE4\uB125\uD130(MCON/SCON)\uC5D0 \uBB34\uD55C\uD68C\uC804 \uC11C\uBCF4\uBAA8\uD130\uB97C \uC9C0\uC815\uB41C \uC18D\uB3C4\uB85C \uD68C\uC804\uC2DC\uD0B5\uB2C8\uB2E4.\n        \n                        \uC18D\uB3C4 = 0 : \uBAA8\uD130\uC758 \uD68C\uC804\uC774 \uBA48\uCDA5\uB2C8\uB2E4.\n                        \uC18D\uB3C4 > 0 : \uBAA8\uD130\uAC00 \uC9C0\uC815\uB41C \uC18D\uB3C4\uB85C \uC815\uBC29\uD5A5 \uD68C\uC804\uD569\uB2C8\uB2E4.\n                        \uC18D\uB3C4 < 0 : \uBAA8\uD130\uAC00 \uC9C0\uC815\uB41C \uC18D\uB3C4\uB85C \uC5ED\uBC29\uD5A5 \uD68C\uC804\uD569\uB2C8\uB2E4.",
              CodeWizLite_Dc_setCarSpeed: "WizCar \uBAA8\uD130\uC5D0 \uC785\uB825\uD55C \uC22B\uC790\uAC12\uC73C\uB85C \uD68C\uC804\uC2DC\uD0B5\uB2C8\uB2E4.\n                        \uAC01 \uBAA8\uD130\uAC12\uC740 -1000~-180(\uD6C4\uC9C4), 180~1000(\uC804\uC9C4) \uC0AC\uC774\uAC12\uC785\uB2C8\uB2E4. \uBC14\uB2E5 \uC0C1\uD0DC\uC5D0 \uB530\uB77C \uC22B\uC790\uAC12\uC744 \uB192\uC5EC\uAC00\uBA74\uC11C \uD68C\uC804\uC744 \uC2DC\uCF1C\uBCF4\uC138\uC694.",
              CodeWizLite_Dc_setValue_Waterpump: "\uC120\uD0DD\uB41C \uC6CC\uD130\uD38C\uD504\uB97C \uC785\uB825\uD55C \uC18D\uB3C4\uB85C \uD68C\uC804\uC2DC\uD0B5\uB2C8\uB2E4.\n                        \u25BC\uC744 \uB20C\uB7EC \uD68C\uC804\uC2DC\uD0AC \uBAA8\uD130(MOTOR_L, MOROT_R)\uB97C \uC120\uD0DD\uD558\uACE0 \uC18D\uB3C4\uB294 0~1023 \uC0AC\uC774 \uAC12\uC73C\uB85C \uC9C1\uC811 \uC785\uB825\uD569\uB2C8\uB2E4.",
              CodeWizLite_DotMatrix_init: "\uB3C4\uD2B8\uB9E4\uD2B8\uB9AD\uC2A4\uAC00 \uC5F0\uACB0\uB41C \uD540\uC744 \uC124\uC815\uD569\uB2C8\uB2E4.\n        \n                        18, 19\uBC88 : SCON                \n                        15, 27\uBC88 : \uD130\uCE58\uC13C\uC11C",
              CodeWizLite_DotMatrix_setBrightness: "\uC785\uB825\uB41C \uAC12\uC73C\uB85C \uB3C4\uD2B8\uB9E4\uD2B8\uB9AD\uC2A4\uC758 \uBC1D\uAE30\uB97C \uC124\uC815\uD569\uB2C8\uB2E4.(1~8)",
              CodeWizLite_DotMatrix_printString: "\uC785\uB825\uB41C \uBB38\uC790\uC5F4\uC744 \uD55C \uAE00\uC790\uC529 \uCD9C\uB825\uD569\uB2C8\uB2E4.",
              // CodeWizLite_DotMatrix_Show_Custom_Image:
              //     '블록에서 선택한 LED를 선택한 밝기로 켭니다. 한번에 모든 LED를 조작할 수 있습니다.',

              CodeWizLite_DotMatrix_setLine: "\uC9C0\uC815\uB41C \uD589/\uC5F4\uC5D0 \uC704\uCE58\uD55C 8\uAC1C LED\uC758 ON/OFF\uB97C \uAC01\uAC01 \uC9C0\uC815\uD574\uC11C \uC81C\uC5B4\uD569\uB2C8\uB2E4.\n        \n                        1 : ON                \n                        0 : OFF",
              CodeWizLite_DotMatrix_setDot: "\uC785\uB825\uB41C \uD589,\uC5F4\uC5D0 \uC704\uCE58\uD55C LED\uC758 ON/OFF\uB97C \uC9C0\uC815\uD569\uB2C8\uB2E4.\n        \n                        \uCF1C\uAE30 : ON\n                        \uB044\uAE30 : OFF",
              CodeWizLite_DotMatrix_clear: "\uC785\uB825\uB41C \uB3C4\uD2B8 \uB9E4\uD2B8\uB9AD\uC2A4\uB97C \uC9C0\uC6C1\uB2C8\uB2E4.(\uB055\uB2C8\uB2E4.)",
              CodeWizLite_DotMatrix_clearAll: "\uC5F0\uACB0\uB41C \uBAA8\uB4E0 \uB3C4\uD2B8 \uB9E4\uD2B8\uB9AD\uC2A4\uB97C \uC9C0\uC6C1\uB2C8\uB2E4.(\uB055\uB2C8\uB2E4.)",
              CodeWizLite_ColorSensor_isColor: "MCON\uC5D0 \uC5F0\uACB0\uB41C \uCEEC\uB7EC\uC13C\uC11C\uC5D0 \uC778\uC2DD\uB41C \uC0C9 \uAC12\uC774 \uC9C0\uC815\uB41C \uC0C9\uC774\uB77C\uBA74 \u2018\uCC38\u2019\uC73C\uB85C \uD310\uB2E8\uD558\uC5EC \uC54C\uB824\uC90D\uB2C8\uB2E4.\n                        \u25BC\uC744 \uBE68\uAC15, \uCD08\uB85D, \uD30C\uB791, \uAC80\uC815, \uD770\uC0C9\uC744 \uC120\uD0DD\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
              CodeWizLite_ColorSensor_getColorValue: "MCON\uC5D0 \uC5F0\uACB0\uB41C \uCEEC\uB7EC\uC13C\uC11C\uC5D0 \uC778\uC2DD\uB41C \uBE68\uAC15\uC758 \uC0C9\uC0C1 \uAC12\uC744 0~255 \uC0AC\uC774\uAC12\uC73C\uB85C \uC54C\uB824\uC90D\uB2C8\uB2E4.\n                        \u25BC\uC744 \uB20C\uB7EC \uCD08\uB85D, \uD30C\uB791\uC744 \uC120\uD0DD\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
              CodeWizLite_DHT_init: "\uC9C0\uC815\uD55C \uD540\uC73C\uB85C \uB514\uC9C0\uD138 \uC628\uC2B5\uB3C4\uB97C \uC124\uC815\uD569\uB2C8\uB2E4.",
              CodeWizLite_DHT_getValue: "\uC55E\uC11C \uC124\uC815\uD55C \uB514\uC9C0\uD138 \uC628\uC2B5\uB3C4\uC5D0\uC11C \uC120\uD0DD\uD55C \uAC12\uC744 \uAC00\uC838\uC635\uB2C8\uB2E4.",
              CodeWizLite_Joystick_setPin: '지정한 핀으로 조이스틱을 설정합니다.',
              CodeWizLite_Joystick_readAxis: '설정된 조이스틱의 지정한 축의 레버값을 읽어옵니다.',
              CodeWizLite_Joystick_readButton: '설정된 조이스틱의 버튼이 눌렸는지 값을 읽어옵니다.',
              CodeWizLite_etcReadSensor_mconRead: "\uAC00\uBCC0\uC800\uD56D/\uC6CC\uD130\uC13C\uC11C/\uD1A0\uC591\uC218\uBD84\uC13C\uC11C\uC758 \uCE21\uC815\uAC12\n                        \uC120\uD0DD\uD55C \uC13C\uC11C\uC5D0 \uB530\uB77C\uC11C \uAC12\uC774 \uC801\uC808\uD788 \uB9E4\uD551\uB418\uC5B4 \uBC18\uD658\uB429\uB2C8\uB2E4.",
              CodeWizLite_etcReadSensor_digitalRead: "\uBC84\uD2BC/\uD3EC\uD1A0\uC778\uD130\uB7FD\uD2B8\uC758 \uCE21\uC815\uAC12\n                        \uD574\uB2F9\uD540\uC758 digitalRead\uAC12\uC744 \uAC00\uC838\uC635\uB2C8\uB2E4.\n                        \uBC84\uD2BC\uC758 \uACBD\uC6B0 \uB20C\uB838\uC744 \uB54C \uCC38\uC744 \uBC18\uD658\uD558\uAE30 \uC704\uD574\uC11C \uC778\uBC84\uC2A4\uB97C \uCDE8\uD558\uACE0,\n                        \uD3EC\uD1A0\uC778\uD130\uB7FD\uD2B8\uB294 \uC77D\uC740 \uAC12 \uADF8\uB300\uB85C \uBC18\uD658\uB429\uB2C8\uB2E4.\n                        ",
              CodeWizLite_etcReadSensor_InfraredThermometerRead: "\uC120\uD0DD\uB41C \uCEE4\uB125\uD130(MCON/SCON)\uC5D0 \uC5F0\uACB0\uB41C \uBE44\uC811\uCD09 \uC628\uB3C4 \uC13C\uC11C\uC5D0 \uC778\uC2DD\uB41C \uC628\uB3C4\uB97C \uC54C\uB824\uC90D\uB2C8\uB2E4.\n                        \u25BC\uC744 \uB20C\uB7EC \uC628\uB3C4 \uB2E8\uC704\uB97C \uC120\uD0DD\uD569\uB2C8\uB2E4."
            }
          }
        };
      }
    }, {
      key: "getBlocks",
      value: function getBlocks() {
        return {
          //region codeino 코드위즈
          CodeWizLite_sensor_title: {
            skeleton: 'basic_text',
            skeletonOptions: {
              box: {
                offsetX: this.getOffsetX(Lang.template.CodeWizLite_sensor_title),
                offsetY: 5
              }
            },
            color: EntryStatic.colorSet.common.TRANSPARENT,
            fontColor: '#333333',
            params: [{
              type: 'Text',
              text: Lang.template.CodeWizLite_sensor_title,
              color: '#333333',
              align: 'left'
            }],
            def: {
              type: 'CodeWizLite_sensor_title'
            },
            "class": 'CodeWizLite_default_sensor',
            isNotFor: ['CodeWizLite'],
            events: {}
          },
          CodeWizLite_get_sensor: {
            // Block UI : %1센서 값
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_string_field',
            fontColor: '#fff',
            params: [{
              type: 'Dropdown',
              options: [['소리', 'SOUND'], ['빛', 'LIGHT'], ['거리', 'DIST'], ['홀', 'HALL'], ['온도', 'tempSensor']],
              value: 'SOUND',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }],
            def: {
              params: [null],
              type: 'CodeWizLite_get_sensor'
            },
            paramsKeyMap: {
              SENSOR: 0
            },
            isNotFor: ['CodeWizLite'],
            "class": 'CodeWizLite_default_sensor',
            func: function func(sprite, script) {
              var _hw_sensorData$sensor;
              var sensor = script.getField('SENSOR', script);
              var hw_sensorData = Entry.CodeWizLite.sensorData;
              return (_hw_sensorData$sensor = hw_sensorData[sensor]) !== null && _hw_sensorData$sensor !== void 0 ? _hw_sensorData$sensor : 0;
            }
          },
          CodeWizLite_get_gyroSensor: {
            // Block UI : 자이로 센서 %1값
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_string_field',
            fontColor: '#fff',
            params: [{
              type: 'Dropdown',
              options: [['X', 'GYRO_X'], ['Y', 'GYRO_Y'], ['Z', 'GYRO_Z']],
              value: 'GYRO_X',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }],
            def: {
              params: [null],
              type: 'CodeWizLite_get_gyroSensor'
            },
            paramsKeyMap: {
              GYRO_TYPE: 0
            },
            isNotFor: ['CodeWizLite'],
            "class": 'CodeWizLite_default_sensor',
            func: function func(sprite, script) {
              var _hw_sensorData$sensor2;
              var sensor = script.getField('GYRO_TYPE', script);
              var hw_sensorData = Entry.CodeWizLite.sensorData;
              return (_hw_sensorData$sensor2 = hw_sensorData[sensor]) !== null && _hw_sensorData$sensor2 !== void 0 ? _hw_sensorData$sensor2 : 0;
            }
          },
          CodeWizLite_isPushedButton: {
            // Block UI : %1 스위치 버튼 값
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic_boolean_field',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [['왼쪽', 'switchButton_26'], ['오른쪽', 'switchButton_4']],
              value: 'switchButton_26',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }],
            events: {},
            def: {
              params: [null],
              type: 'CodeWizLite_isPushedButton'
            },
            paramsKeyMap: {
              SWITCH: 0
            },
            isNotFor: ['CodeWizLite'],
            "class": 'CodeWizLite_default_sensor',
            func: function func(sprite, script) {
              var _hw_sensorData$sensor3;
              var sensor = script.getField('SWITCH', script);
              var hw_sensorData = Entry.CodeWizLite.sensorData;
              return (_hw_sensorData$sensor3 = hw_sensorData[sensor]) !== null && _hw_sensorData$sensor3 !== void 0 ? _hw_sensorData$sensor3 : false;
            }
          },
          CodeWizLite_touchPin: {
            // Block UI : "터치핀 %1 값",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic_boolean_field',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [['🔆(13)', 'touchPin_13'], ['⭕(14)', 'touchPin_14'], ['🖐(15)', 'touchPin_15'], ['👊(27)', 'touchPin_27'], ['🐻(32)', 'touchPin_32'], ['❌(33)', 'touchPin_33']],
              value: 'touchPin_32',
              fontSize: 14,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }],
            events: {},
            def: {
              params: [null],
              type: 'CodeWizLite_touchPin'
            },
            paramsKeyMap: {
              SWITCH: 0
            },
            isNotFor: ['CodeWizLite'],
            "class": 'CodeWizLite_default_sensor',
            func: function func(sprite, script) {
              var _hw_sensorData$sensor4;
              var sensor = script.getField('SWITCH', script);
              var hw_sensorData = Entry.CodeWizLite.sensorData;
              return (_hw_sensorData$sensor4 = hw_sensorData[sensor]) !== null && _hw_sensorData$sensor4 !== void 0 ? _hw_sensorData$sensor4 : 0;
            }
          },
          CodeWizLite_buzzer_title: {
            skeleton: 'basic_text',
            skeletonOptions: {
              box: {
                offsetX: this.getOffsetX(Lang.template.CodeWizLite_buzzer_title),
                offsetY: 5
              }
            },
            color: EntryStatic.colorSet.common.TRANSPARENT,
            fontColor: '#333333',
            params: [{
              type: 'Text',
              text: Lang.template.CodeWizLite_buzzer_title,
              color: '#333333',
              align: 'left'
            }],
            def: {
              type: 'CodeWizLite_buzzer_title'
            },
            "class": 'CodeWizLite_buzzer',
            isNotFor: ['CodeWizLite'],
            events: {}
          },
          CodeWizLite_default_buzzer: {
            // Block UI : "스피커를 %1옥타브, %2음, %3분음표로 연주하기%4",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [['1', '1'], ['2', '2'], ['3', '3'], ['4', '4'], ['5', '5'], ['6', '6'], ['7', '7']],
              value: '4',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Dropdown',
              options: [['도', '0'], ['도#', '1'], ['레', '2'], ['미♭', '3'], ['미', '4'], ['파', '5'], ['파#', '6'], ['솔', '7'], ['솔#', '8'], ['라', '9'], ['시♭', '10'], ['시', '11']],
              value: '0',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Dropdown',
              options: [['2', '2'], ['4', '4'], ['8', '8'], ['16', '16'], ['32', '32']],
              value: '4',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null, null, null],
              type: 'CodeWizLite_default_buzzer'
            },
            paramsKeyMap: {
              OCTAVE: 0,
              NOTE: 1,
              BEAT: 2
            },
            "class": 'CodeWizLite_buzzer',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
                var octave, note, beat, order, id;
                return _regenerator["default"].wrap(function (_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context2.next = 1;
                        break;
                      }
                      _context2.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      octave = Number.parseInt(script.getValue('OCTAVE', script));
                      note = Number.parseInt(script.getValue('NOTE', script));
                      beat = Number.parseInt(script.getValue('BEAT', script));
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 1,
                          params: [octave, note, beat]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context2.next = 2;
                      return Entry.CodeWizLite.checkComplete(1234, id);
                    case 2:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2);
              }))();
            }
          },
          CodeWizLite_neopixel_title: {
            skeleton: 'basic_text',
            skeletonOptions: {
              box: {
                offsetX: this.getOffsetX(Lang.template.CodeWizLite_neopixel_title),
                offsetY: 5
              }
            },
            color: EntryStatic.colorSet.common.TRANSPARENT,
            fontColor: '#333333',
            params: [{
              type: 'Text',
              text: Lang.template.CodeWizLite_neopixel_title,
              color: '#333333',
              align: 'left'
            }],
            def: {
              type: 'CodeWizLite_neopixel_title'
            },
            "class": 'CodeWizLite_neopixel',
            isNotFor: ['CodeWizLite'],
            events: {}
          },
          CodeWizLite_neopixel_init: {
            // Block UI : "네오픽셀 %1에 %2개로 시작설정%3",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [['코드위즈', '23'], ['18', '18'], ['19', '19']],
              value: '23',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Block',
              accept: 'string',
              defaultType: 'number',
              value: 5
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null],
              type: 'CodeWizLite_neopixel_init'
            },
            paramsKeyMap: {
              PIN: 0,
              COUNT: 1
            },
            "class": 'CodeWizLite_neopixel',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
                var _pin, _count, order, id;
                return _regenerator["default"].wrap(function (_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context3.next = 1;
                        break;
                      }
                      _context3.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _pin = script.getNumberValue('PIN', script);
                      _count = script.getNumberValue('COUNT', script);
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 32,
                          params: [_pin, _count]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context3.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee3);
              }))();
            }
          },
          CodeWizLite_neopixel_brightness: {
            // Block UI : "네오픽셀 밝기를 %1로 설정(0~255)%2",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string',
              defaultType: 'number',
              value: 22
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null, null],
              type: 'CodeWizLite_neopixel_brightness'
            },
            paramsKeyMap: {
              BRIGHTNESS: 0
            },
            "class": 'CodeWizLite_neopixel',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4() {
                var value, order, id;
                return _regenerator["default"].wrap(function (_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context4.next = 1;
                        break;
                      }
                      _context4.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      value = script.getNumberValue('BRIGHTNESS', script);
                      value = Math.round(value);
                      if (value < 0) {
                        value = 0;
                      } else if (value > 255) {
                        value = 255;
                      }
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 2,
                          params: [value]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context4.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context4.stop();
                  }
                }, _callee4);
              }))();
            }
          },
          CodeWizLite_neopixel_setColor_one: {
            // Block UI : "네오픽셀 %1번 LED를 <색상표>%2(으)로 켜기%3",

            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Color'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: ['1', null, null],
              type: 'CodeWizLite_neopixel_setColor_one'
            },
            paramsKeyMap: {
              NUM: 0,
              COLOR: 1
            },
            "class": 'CodeWizLite_neopixel',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5() {
                var num, value, colorValue, order, id;
                return _regenerator["default"].wrap(function (_context5) {
                  while (1) switch (_context5.prev = _context5.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context5.next = 1;
                        break;
                      }
                      _context5.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      num = script.getNumberValue('NUM', script) - 1;
                      value = script.getStringField('COLOR', script);
                      colorValue = [parseInt(value.substr(1, 2), 16), parseInt(value.substr(3, 2), 16), parseInt(value.substr(5, 2), 16)];
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 3,
                          params: [num].concat(colorValue)
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context5.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context5.stop();
                  }
                }, _callee5);
              }))();
            }
          },
          CodeWizLite_neopixel_setColor_one2: {
            // Block UI : "네오픽셀 %1번 LED를 빨강%2초록%3파랑%4(으)로 켜기%5",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: ['1', '255', '255', '255', null],
              type: 'CodeWizLite_neopixel_setColor_one2'
            },
            paramsKeyMap: {
              NUM: 0,
              R: 1,
              G: 2,
              B: 3
            },
            "class": 'CodeWizLite_neopixel',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6() {
                var num, r, g, b, order, id;
                return _regenerator["default"].wrap(function (_context6) {
                  while (1) switch (_context6.prev = _context6.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context6.next = 1;
                        break;
                      }
                      _context6.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      num = script.getNumberValue('NUM', script) - 1;
                      r = script.getNumberValue('R', script);
                      g = script.getNumberValue('G', script);
                      b = script.getNumberValue('B', script);
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 3,
                          params: [num, r, g, b]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context6.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context6.stop();
                  }
                }, _callee6);
              }))();
            }
          },
          CodeWizLite_neopixel_off_one: {
            // Block UI : "네오픽셀 %1번 LED 끄기%2",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: ['1', null],
              type: 'CodeWizLite_neopixel_off_one'
            },
            paramsKeyMap: {
              NUM: 0
            },
            "class": 'CodeWizLite_neopixel',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7() {
                var num, order, id;
                return _regenerator["default"].wrap(function (_context7) {
                  while (1) switch (_context7.prev = _context7.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context7.next = 1;
                        break;
                      }
                      _context7.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      num = script.getNumberValue('NUM', script) - 1;
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 4,
                          params: [num]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context7.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context7.stop();
                  }
                }, _callee7);
              }))();
            }
          },
          CodeWizLite_neopixel_setColor_all: {
            // Block UI : "네오픽셀 %1(으)로 모두 켜기%2",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Color'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null],
              type: 'CodeWizLite_neopixel_setColor_all'
            },
            paramsKeyMap: {
              COLOR: 0
            },
            "class": 'CodeWizLite_neopixel',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee8() {
                var value, colorValue, order, id;
                return _regenerator["default"].wrap(function (_context8) {
                  while (1) switch (_context8.prev = _context8.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context8.next = 1;
                        break;
                      }
                      _context8.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      value = script.getStringField('COLOR', script);
                      colorValue = [parseInt(value.substr(1, 2), 16), parseInt(value.substr(3, 2), 16), parseInt(value.substr(5, 2), 16)];
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 5,
                          params: [].concat(colorValue)
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context8.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context8.stop();
                  }
                }, _callee8);
              }))();
            }
          },
          CodeWizLite_neopixel_setColor_all2: {
            // Block UI : "네오픽셀 빨강%1초록%2파랑%3(으)로 모두 켜기%4",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: ['255', '255', '255', null],
              type: 'CodeWizLite_neopixel_setColor_all2'
            },
            paramsKeyMap: {
              R: 0,
              G: 1,
              B: 2
            },
            "class": 'CodeWizLite_neopixel',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee9() {
                var r, g, b, order, id;
                return _regenerator["default"].wrap(function (_context9) {
                  while (1) switch (_context9.prev = _context9.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context9.next = 1;
                        break;
                      }
                      _context9.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      r = script.getNumberValue('R', script);
                      g = script.getNumberValue('G', script);
                      b = script.getNumberValue('B', script);
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 5,
                          params: [r, g, b]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context9.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context9.stop();
                  }
                }, _callee9);
              }))();
            }
          },
          CodeWizLite_neopixel_off_all: {
            // Block UI : "네오픽셀 모두 끄기%1",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [],
              type: 'CodeWizLite_neopixel_off_all'
            },
            paramsKeyMap: {},
            "class": 'CodeWizLite_neopixel',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee0() {
                var order, id;
                return _regenerator["default"].wrap(function (_context0) {
                  while (1) switch (_context0.prev = _context0.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context0.next = 1;
                        break;
                      }
                      _context0.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 6,
                          params: []
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context0.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context0.stop();
                  }
                }, _callee0);
              }))();
            }
          },
          CodeWizLite_neopixel_OnPixelRandomColor: {
            // 랜덤색상 켜기 - 단일
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: ['1', null],
              type: 'CodeWizLite_neopixel_OnPixelRandomColor'
            },
            paramsKeyMap: {
              NUM: 0
            },
            "class": 'CodeWizLite_neopixel',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee1() {
                var num, order, id;
                return _regenerator["default"].wrap(function (_context1) {
                  while (1) switch (_context1.prev = _context1.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context1.next = 1;
                        break;
                      }
                      _context1.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      num = script.getNumberValue('NUM', script) - 1;
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 3,
                          params: [num, Math.floor(Math.random() * 256), Math.floor(Math.random() * 256), Math.floor(Math.random() * 256)]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context1.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context1.stop();
                  }
                }, _callee1);
              }))();
            }
          },
          CodeWizLite_neopixel_fillRandom: {
            // 랜덤색상 켜기 - 전체
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [],
              type: 'CodeWizLite_neopixel_fillRandom'
            },
            paramsKeyMap: {},
            "class": 'CodeWizLite_neopixel',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee10() {
                var order, id;
                return _regenerator["default"].wrap(function (_context10) {
                  while (1) switch (_context10.prev = _context10.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context10.next = 1;
                        break;
                      }
                      _context10.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 43,
                          params: []
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context10.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context10.stop();
                  }
                }, _callee10);
              }))();
            }
          },
          CodeWizLite_neopixel_rotate: {
            // rotate 네오픽셀
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [['역방향', '0'], ['정방향', '1']],
              value: '1',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null],
              type: 'CodeWizLite_neopixel_rotate'
            },
            paramsKeyMap: {
              DIR: 0
            },
            "class": 'CodeWizLite_neopixel',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee11() {
                var _dir, order, id;
                return _regenerator["default"].wrap(function (_context11) {
                  while (1) switch (_context11.prev = _context11.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context11.next = 1;
                        break;
                      }
                      _context11.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _dir = script.getNumberValue('DIR', script);
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 44,
                          params: [_dir]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context11.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context11.stop();
                  }
                }, _callee11);
              }))();
            }
          },
          CodeWizLite_neopixel_shift: {
            // shift 네오픽셀
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [['역방향', '0'], ['정방향', '1']],
              value: '1',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null],
              type: 'CodeWizLite_neopixel_shift'
            },
            paramsKeyMap: {
              DIR: 0
            },
            "class": 'CodeWizLite_neopixel',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee12() {
                var _dir, order, id;
                return _regenerator["default"].wrap(function (_context12) {
                  while (1) switch (_context12.prev = _context12.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context12.next = 1;
                        break;
                      }
                      _context12.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _dir = script.getNumberValue('DIR', script);
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 45,
                          params: [_dir]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context12.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context12.stop();
                  }
                }, _callee12);
              }))();
            }
          },
          CodeWizLite_neopixel_gradationRGB: {
            // RGB그라데이션
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Color'
            }, {
              type: 'Color'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: ['1', '8', '#ff0000', '#00ff00'],
              type: 'CodeWizLite_neopixel_gradationRGB'
            },
            paramsKeyMap: {
              START: 0,
              END: 1,
              S_COLOR: 2,
              E_COLOR: 3
            },
            "class": 'CodeWizLite_neopixel',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee13() {
                var _start, _end, _sColor, _eColor, order, id;
                return _regenerator["default"].wrap(function (_context13) {
                  while (1) switch (_context13.prev = _context13.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context13.next = 1;
                        break;
                      }
                      _context13.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _start = script.getNumberValue('START', script) - 1;
                      _end = script.getNumberValue('END', script) - 1;
                      _sColor = script.getStringField('S_COLOR', script);
                      _eColor = script.getStringField('E_COLOR', script);
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 46,
                          params: [_start, _end, _sColor, _eColor]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context13.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context13.stop();
                  }
                }, _callee13);
              }))();
            }
          },
          CodeWizLite_neopixel_gradationHSL: {
            // HSL그라데이션
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Color'
            }, {
              type: 'Color'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: ['1', '8', '#ff0000', '#611ca1'],
              type: 'CodeWizLite_neopixel_gradationHSL'
            },
            paramsKeyMap: {
              START: 0,
              END: 1,
              S_COLOR: 2,
              E_COLOR: 3
            },
            "class": 'CodeWizLite_neopixel',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee14() {
                var _start, _end, _sColor, _eColor, order, id;
                return _regenerator["default"].wrap(function (_context14) {
                  while (1) switch (_context14.prev = _context14.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context14.next = 1;
                        break;
                      }
                      _context14.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _start = script.getNumberValue('START', script) - 1;
                      _end = script.getNumberValue('END', script) - 1;
                      _sColor = script.getStringField('S_COLOR', script);
                      _eColor = script.getStringField('E_COLOR', script);
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 47,
                          params: [_start, _end, _sColor, _eColor]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context14.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context14.stop();
                  }
                }, _callee14);
              }))();
            }
          },
          CodeWizLite_neopixel_wheeeeeeel: {
            // 휠 - 엔트리에선 느려서 활용도가 떨어질 것으로 예상해서 일단 주석
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [],
              type: 'CodeWizLite_neopixel_wheeeeeeel'
            },
            paramsKeyMap: {},
            "class": 'CodeWizLite_neopixel',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee15() {
                var order, id;
                return _regenerator["default"].wrap(function (_context15) {
                  while (1) switch (_context15.prev = _context15.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context15.next = 1;
                        break;
                      }
                      _context15.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 49,
                          params: []
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order); // console.log(script.key);
                      _context15.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context15.stop();
                  }
                }, _callee15);
              }))();
            }
          },
          CodeWizLite_OLED_title: {
            skeleton: 'basic_text',
            skeletonOptions: {
              box: {
                offsetX: this.getOffsetX(Lang.template.CodeWizLite_OLED_title),
                offsetY: 5
              }
            },
            color: EntryStatic.colorSet.common.TRANSPARENT,
            fontColor: '#333333',
            params: [{
              type: 'Text',
              text: Lang.template.CodeWizLite_OLED_title,
              color: '#333333',
              align: 'left'
            }],
            def: {
              type: 'CodeWizLite_OLED_title'
            },
            "class": 'CodeWizLite_OLED',
            isNotFor: ['CodeWizLite'],
            events: {}
          },
          CodeWizLite_OLED_clear: {
            // Block UI : "OLED 지우기%1",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [],
              type: 'CodeWizLite_OLED_clear'
            },
            paramsKeyMap: {},
            "class": 'CodeWizLite_OLED',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee16() {
                var order, id;
                return _regenerator["default"].wrap(function (_context16) {
                  while (1) switch (_context16.prev = _context16.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context16.next = 1;
                        break;
                      }
                      _context16.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 7,
                          params: []
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context16.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context16.stop();
                  }
                }, _callee16);
              }))();
            }
          },
          CodeWizLite_OLED_mirror: {
            // Block UI : "OLED 반전모드%1 %2",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [['OFF', '0'], ['ON', '1']],
              value: '0',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null],
              type: 'CodeWizLite_OLED_mirror'
            },
            paramsKeyMap: {
              SWITCH: 0
            },
            "class": 'CodeWizLite_OLED',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee17() {
                var _value, order, id;
                return _regenerator["default"].wrap(function (_context17) {
                  while (1) switch (_context17.prev = _context17.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context17.next = 1;
                        break;
                      }
                      _context17.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _value = script.getNumberValue('SWITCH', script);
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 8,
                          params: [_value]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context17.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context17.stop();
                  }
                }, _callee17);
              }))();
            }
          },
          CodeWizLite_OLED_setSize: {
            // Block UI : "OLED 문자 크기를 %1(으)로 설정%2",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [3],
              type: 'CodeWizLite_OLED_setSize'
            },
            paramsKeyMap: {
              SIZE: 0
            },
            "class": 'CodeWizLite_OLED',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee18() {
                var _value, order, id;
                return _regenerator["default"].wrap(function (_context18) {
                  while (1) switch (_context18.prev = _context18.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context18.next = 1;
                        break;
                      }
                      _context18.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _value = script.getNumberValue('SIZE', script);
                      _value = Math.round(_value);
                      if (_value < 1) {
                        _value = 1;
                      } else if (_value > 10) {
                        _value = 10;
                      }
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 9,
                          params: [_value]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context18.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context18.stop();
                  }
                }, _callee18);
              }))();
            }
          },
          CodeWizLite_OLED_setPosition: {
            // Block UI : "OLED 커서위치(%1,%2)(으)로 지정%3",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: ['0', '0'],
              type: 'CodeWizLite_OLED_setPosition'
            },
            paramsKeyMap: {
              X: 0,
              Y: 1
            },
            "class": 'CodeWizLite_OLED',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee19() {
                var _x, _y, order, id;
                return _regenerator["default"].wrap(function (_context19) {
                  while (1) switch (_context19.prev = _context19.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context19.next = 1;
                        break;
                      }
                      _context19.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _x = script.getNumberValue('X', script);
                      _x = Math.round(_x);
                      if (_x < 0) {
                        _x = 0;
                      } else if (_x > 255) {
                        _x = 255;
                      }
                      _y = script.getNumberValue('Y', script);
                      _y = Math.round(_y);
                      if (_y < 0) {
                        _y = 0;
                      } else if (_y > 255) {
                        _y = 255;
                      }
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 10,
                          params: [_x, _y]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context19.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context19.stop();
                  }
                }, _callee19);
              }))();
            }
          },
          CodeWizLite_OLED_println: {
            // Block UI : "OLED에 %1 출력%2",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: ['Hello, World!!'],
              type: 'CodeWizLite_OLED_println'
            },
            paramsKeyMap: {
              TEXT: 0
            },
            "class": 'CodeWizLite_OLED',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee20() {
                var _value, order, id;
                return _regenerator["default"].wrap(function (_context20) {
                  while (1) switch (_context20.prev = _context20.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context20.next = 1;
                        break;
                      }
                      _context20.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _value = script.getStringValue('TEXT');
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 11,
                          params: [_value]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context20.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context20.stop();
                  }
                }, _callee20);
              }))();
            }
          },
          CodeWizLite_OLED_isCollision: {
            // Block UI : "OLED 문자겹침 모드%1%2",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [['OFF', '0'], ['ON', '1']],
              value: '1',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null],
              type: 'CodeWizLite_OLED_isCollision'
            },
            paramsKeyMap: {
              SWITCH: 0
            },
            "class": 'CodeWizLite_OLED',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee21() {
                var _value, order, id;
                return _regenerator["default"].wrap(function (_context21) {
                  while (1) switch (_context21.prev = _context21.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context21.next = 1;
                        break;
                      }
                      _context21.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _value = script.getNumberValue('SWITCH', script);
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 12,
                          params: [_value]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context21.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context21.stop();
                  }
                }, _callee21);
              }))();
            }
          },
          CodeWizLite_OLED_specialChar: {
            // Block UI : "OLED에 기호%1 출력하기%2",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [['♥', '3'], ['◆', '4'], ['♣', '5'], ['♠', '6'], ['♬', '14'], ['▲', '30'], ['▼', '31'], ['😧', '1'], ['😀', '2'], ['♂', '11'], ['♀', '12'], ['↑', '24'], ['↓', '25'], ['→', '26'], ['←', '27']],
              value: '14',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null],
              type: 'CodeWizLite_OLED_specialChar'
            },
            paramsKeyMap: {
              CHAR: 0
            },
            "class": 'CodeWizLite_OLED',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee22() {
                var _value, order, id;
                return _regenerator["default"].wrap(function (_context22) {
                  while (1) switch (_context22.prev = _context22.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context22.next = 1;
                        break;
                      }
                      _context22.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _value = script.getNumberValue('CHAR', script);
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 13,
                          params: [_value]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context22.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context22.stop();
                  }
                }, _callee22);
              }))();
            }
          },
          CodeWizLite_OLED_setFont: {
            // Block UI : "OLED 폰트%1를 크기%2(으)로 설정%3",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [['Serif', '0'], ['Sans', '1'], ['Mono', '2']],
              value: '2',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Dropdown',
              options: [['9', '0'], ['12', '1'], ['18', '2']],
              value: '0',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null, null],
              type: 'CodeWizLite_OLED_setFont'
            },
            paramsKeyMap: {
              FONT: 0,
              SIZE: 1
            },
            "class": 'CodeWizLite_OLED',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee23() {
                var _value, _size, order, id;
                return _regenerator["default"].wrap(function (_context23) {
                  while (1) switch (_context23.prev = _context23.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context23.next = 1;
                        break;
                      }
                      _context23.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _value = script.getNumberValue('FONT', script);
                      _size = script.getNumberValue('SIZE', script);
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 14,
                          params: [_value, _size]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context23.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context23.stop();
                  }
                }, _callee23);
              }))();
            }
          },
          CodeWizLite_OLED_startScroll: {
            // Block UI : "OLED 스크롤 시키기 옵션(%1, 범위%2~%3(0~7))%4",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [['→', '0'], ['←', '1'], ['↗', '2'], ['↖', '3']],
              value: '0',
              fontSize: 14,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null, '0', '0'],
              type: 'CodeWizLite_OLED_startScroll'
            },
            paramsKeyMap: {
              DIRECTION: 0,
              START: 1,
              END: 2
            },
            "class": 'CodeWizLite_OLED',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee24() {
                var _value, _st, _ed, order, id;
                return _regenerator["default"].wrap(function (_context24) {
                  while (1) switch (_context24.prev = _context24.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context24.next = 1;
                        break;
                      }
                      _context24.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _value = Number.parseInt(script.getNumberValue('DIRECTION', script));
                      _st = Number.parseInt(script.getNumberValue('START', script));
                      _st = Math.round(_st);
                      if (_st < 0) {
                        _x = 0;
                      } else if (_st > 7) {
                        _st = 7;
                      }
                      _ed = script.getNumberValue('END', script);
                      _ed = Math.round(_ed);
                      if (_ed < 0) {
                        _ed = 0;
                      } else if (_ed > 7) {
                        _ed = 7;
                      }
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 15,
                          params: [_value, _st, _ed]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context24.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context24.stop();
                  }
                }, _callee24);
              }))();
            }
          },
          CodeWizLite_OLED_stopScroll: {
            // Block UI : "OLED 스크롤 멈추기%1",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [],
              type: 'CodeWizLite_OLED_stopScroll'
            },
            paramsKeyMap: {},
            "class": 'CodeWizLite_OLED',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee25() {
                var order, id;
                return _regenerator["default"].wrap(function (_context25) {
                  while (1) switch (_context25.prev = _context25.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context25.next = 1;
                        break;
                      }
                      _context25.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 16,
                          params: []
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context25.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context25.stop();
                  }
                }, _callee25);
              }))();
            }
          },
          CodeWizLite_OLED_drawPoint: {
            // Block UI : "OLED에 점찍기 옵션((%1,%2), %3)%4",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Dropdown',
              options: [['검은색', '0'], ['흰색', '1']],
              value: '1',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [63, 31, null],
              type: 'CodeWizLite_OLED_drawPoint'
            },
            paramsKeyMap: {
              X: 0,
              Y: 1,
              COLOR: 2
            },
            "class": 'CodeWizLite_OLED',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee26() {
                var _x, _y, _color, order, id;
                return _regenerator["default"].wrap(function (_context26) {
                  while (1) switch (_context26.prev = _context26.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context26.next = 1;
                        break;
                      }
                      _context26.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _x = script.getNumberValue('X', script);
                      _x = Math.round(_x);
                      if (_x < 0) {
                        _x = 0;
                      } else if (_x > 128) {
                        _x = 128;
                      }
                      _y = script.getNumberValue('Y', script);
                      _y = Math.round(_y);
                      if (_y < 0) {
                        _y = 0;
                      } else if (_y > 64) {
                        _y = 64;
                      }
                      _color = script.getNumberValue('COLOR', script);
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 17,
                          params: [_x, _y, _color]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context26.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context26.stop();
                  }
                }, _callee26);
              }))();
            }
          },
          CodeWizLite_OLED_drawLine1: {
            // Block UI : "OLED에 선 그리기 옵션((%1,%2)~(%3,%4), %5)%6",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Dropdown',
              options: [['검은색', '0'], ['흰색', '1']],
              value: '1',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: ['0', '0', '10', '0', null],
              type: 'CodeWizLite_OLED_drawLine1'
            },
            paramsKeyMap: {
              SX: 0,
              SY: 1,
              EX: 2,
              EY: 3,
              COLOR: 4
            },
            "class": 'CodeWizLite_OLED',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee27() {
                var _sx, _sy, _ex, _ey, _color, order, id;
                return _regenerator["default"].wrap(function (_context27) {
                  while (1) switch (_context27.prev = _context27.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context27.next = 1;
                        break;
                      }
                      _context27.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _sx = script.getNumberValue('SX', script);
                      _sx = Math.round(_sx);
                      if (_sx < 0) {
                        _sx = 0;
                      } else if (_sx > 128) {
                        _sx = 128;
                      }
                      _sy = script.getNumberValue('SY', script);
                      _sy = Math.round(_sy);
                      if (_sy < 0) {
                        _sy = 0;
                      } else if (_sy > 64) {
                        _sy = 64;
                      }
                      _ex = script.getNumberValue('EX', script);
                      _ex = Math.round(_ex);
                      if (_ex < 0) {
                        _ex = 0;
                      } else if (_ex > 128) {
                        _ex = 128;
                      }
                      _ey = script.getNumberValue('EY', script);
                      _ey = Math.round(_ey);
                      if (_ey < 0) {
                        _ey = 0;
                      } else if (_ey > 64) {
                        _ey = 64;
                      }
                      _color = script.getNumberValue('COLOR', script);
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 18,
                          params: [_sx, _sy, _ex, _ey, _color]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context27.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context27.stop();
                  }
                }, _callee27);
              }))();
            }
          },
          CodeWizLite_OLED_drawLine2: {
            // Block UI : "OLED에 수직 선 그리기 옵션((%1,%2), 길이%3, %4)%5",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Dropdown',
              options: [['검은색', '0'], ['흰색', '1']],
              value: '1',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: ['0', '0', '10', null],
              type: 'CodeWizLite_OLED_drawLine2'
            },
            paramsKeyMap: {
              SX: 0,
              SY: 1,
              LEN: 2,
              COLOR: 3
            },
            "class": 'CodeWizLite_OLED',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee28() {
                var _sx, _sy, _len, _color, order, id;
                return _regenerator["default"].wrap(function (_context28) {
                  while (1) switch (_context28.prev = _context28.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context28.next = 1;
                        break;
                      }
                      _context28.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _sx = script.getNumberValue('SX', script);
                      _sx = Math.round(_sx);
                      if (_sx < 0) {
                        _sx = 0;
                      } else if (_sx > 128) {
                        _sx = 128;
                      }
                      _sy = script.getNumberValue('SY', script);
                      _sy = Math.round(_sy);
                      if (_sy < 0) {
                        _sy = 0;
                      } else if (_sy > 64) {
                        _sy = 64;
                      }
                      _len = script.getNumberValue('LEN', script);
                      _len = Math.round(_len);
                      if (_len < 0) {
                        _len = 0;
                      } else if (_len > 64) {
                        _len = 64;
                      }
                      _color = script.getNumberValue('COLOR', script);
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 19,
                          params: [_sx, _sy, _len, _color]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context28.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context28.stop();
                  }
                }, _callee28);
              }))();
            }
          },
          CodeWizLite_OLED_drawLine3: {
            // Block UI : "OLED에 수평 선 그리기 옵션((%1,%2), 길이%3, %4)%5",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Dropdown',
              options: [['검은색', '0'], ['흰색', '1']],
              value: '1',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: ['0', '0', '10', null],
              type: 'CodeWizLite_OLED_drawLine3'
            },
            paramsKeyMap: {
              SX: 0,
              SY: 1,
              LEN: 2,
              COLOR: 3
            },
            "class": 'CodeWizLite_OLED',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee29() {
                var _sx, _sy, _len, _color, order, id;
                return _regenerator["default"].wrap(function (_context29) {
                  while (1) switch (_context29.prev = _context29.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context29.next = 1;
                        break;
                      }
                      _context29.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _sx = script.getNumberValue('SX', script);
                      _sx = Math.round(_sx);
                      if (_sx < 0) {
                        _sx = 0;
                      } else if (_sx > 128) {
                        _sx = 128;
                      }
                      _sy = script.getNumberValue('SY', script);
                      _sy = Math.round(_sy);
                      if (_sy < 0) {
                        _sy = 0;
                      } else if (_sy > 64) {
                        _sy = 64;
                      }
                      _len = script.getNumberValue('LEN', script);
                      _len = Math.round(_len);
                      if (_len < 0) {
                        _len = 0;
                      } else if (_len > 128) {
                        _len = 128;
                      }
                      _color = script.getNumberValue('COLOR', script);
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 20,
                          params: [_sx, _sy, _len, _color]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context29.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context29.stop();
                  }
                }, _callee29);
              }))();
            }
          },
          CodeWizLite_OLED_drawRect: {
            // Block UI : "OLED에 직사각형 그리기 옵션(좌상단점(%1,%2), 가로%3, 세로%4, %5, %6)%7",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Dropdown',
              options: [['비움', '0'], ['채움', '1']],
              value: '0',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Dropdown',
              options: [['검은색', '0'], ['흰색', '1']],
              value: '1',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: ['0', '0', '10', '10', null, null],
              type: 'CodeWizLite_OLED_drawRect'
            },
            paramsKeyMap: {
              SX: 0,
              SY: 1,
              WIDTH: 2,
              HEIGHT: 3,
              ISFILL: 4,
              COLOR: 5
            },
            "class": 'CodeWizLite_OLED',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee30() {
                var _sx, _sy, _width, _height, _isFill, _color, order, id;
                return _regenerator["default"].wrap(function (_context30) {
                  while (1) switch (_context30.prev = _context30.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context30.next = 1;
                        break;
                      }
                      _context30.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _sx = script.getNumberValue('SX', script);
                      _sx = Math.round(_sx);
                      if (_sx < 0) {
                        _sx = 0;
                      } else if (_sx > 128) {
                        _sx = 128;
                      }
                      _sy = script.getNumberValue('SY', script);
                      _sy = Math.round(_sy);
                      if (_sy < 0) {
                        _sy = 0;
                      } else if (_sy > 64) {
                        _sy = 64;
                      }
                      _width = script.getNumberValue('WIDTH', script);
                      _width = Math.round(_width);
                      if (_width < 0) {
                        _width = 0;
                      } else if (_width > 128) {
                        _width = 128;
                      }
                      _height = script.getNumberValue('HEIGHT', script);
                      _height = Math.round(_height);
                      if (_height < 0) {
                        _height = 0;
                      } else if (_height > 64) {
                        _height = 64;
                      }
                      _isFill = script.getNumberValue('ISFILL', script);
                      _color = script.getNumberValue('COLOR', script);
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 21,
                          x: _sx,
                          y: _sy,
                          params: [_sx, _sy, _width, _height, _isFill, _color]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context30.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context30.stop();
                  }
                }, _callee30);
              }))();
            }
          },
          CodeWizLite_OLED_drawCircle: {
            // Block UI : "OLED에 원 그리기 옵션(중심(%1,%2) 반지름%3, %4, %5)%6",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Dropdown',
              options: [['비움', '0'], ['채움', '1']],
              value: '0',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Dropdown',
              options: [['검은색', '0'], ['흰색', '1']],
              value: '1',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: ['30', '30', '10', null, null],
              type: 'CodeWizLite_OLED_drawCircle'
            },
            paramsKeyMap: {
              RX: 0,
              RY: 1,
              RAD: 2,
              ISFILL: 3,
              COLOR: 4
            },
            "class": 'CodeWizLite_OLED',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee31() {
                var _rx, _ry, _rad, _isFill, _color, order, id;
                return _regenerator["default"].wrap(function (_context31) {
                  while (1) switch (_context31.prev = _context31.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context31.next = 1;
                        break;
                      }
                      _context31.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _rx = script.getNumberValue('RX', script);
                      _rx = Math.round(_rx);
                      if (_rx < 0) {
                        _rx = 0;
                      } else if (_rx > 128) {
                        _rx = 128;
                      }
                      _ry = script.getNumberValue('RY', script);
                      _ry = Math.round(_ry);
                      if (_ry < 0) {
                        _ry = 0;
                      } else if (_ry > 64) {
                        _ry = 64;
                      }
                      _rad = script.getNumberValue('RAD', script);
                      _rad = Math.round(_rad);
                      if (_rad < 0) {
                        _rad = 0;
                      } else if (_rad > 255) {
                        _rad = 255;
                      }
                      _isFill = script.getNumberValue('ISFILL', script);
                      _color = script.getNumberValue('COLOR', script);
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 22,
                          params: [_rx, _ry, _rad, _isFill, _color]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context31.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context31.stop();
                  }
                }, _callee31);
              }))();
            }
          },
          CodeWizLite_OLED_drawPoligon: {
            // Block UI : "OLED에 삼각형 그리기 옵션((%1,%2), (%3,%4), (%5,%6), %7, %8)%9",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Dropdown',
              options: [['비움', '0'], ['채움', '1']],
              value: '0',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Dropdown',
              options: [['검은색', '0'], ['흰색', '1']],
              value: '1',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: ['0', '9', '6', '9', '3', '0', null, null],
              type: 'CodeWizLite_OLED_drawPoligon'
            },
            paramsKeyMap: {
              X1: 0,
              Y1: 1,
              X2: 2,
              Y2: 3,
              X3: 4,
              Y3: 5,
              ISFILL: 6,
              COLOR: 7
            },
            "class": 'CodeWizLite_OLED',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee32() {
                var _x1, _y1, _x2, _y2, _x3, _y3, _isFill, _color, order, id;
                return _regenerator["default"].wrap(function (_context32) {
                  while (1) switch (_context32.prev = _context32.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context32.next = 1;
                        break;
                      }
                      _context32.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _x1 = script.getNumberValue('X1', script);
                      _x1 = Math.round(_x1);
                      if (_x1 < 0) {
                        _x1 = 0;
                      } else if (_x1 > 128) {
                        _x1 = 128;
                      }
                      _y1 = script.getNumberValue('Y1', script);
                      _y1 = Math.round(_y1);
                      if (_y1 < 0) {
                        _y1 = 0;
                      } else if (_y1 > 64) {
                        _y1 = 64;
                      }
                      _x2 = script.getNumberValue('X2', script);
                      _x2 = Math.round(_x2);
                      if (_x2 < 0) {
                        _x2 = 0;
                      } else if (_x2 > 128) {
                        _x2 = 128;
                      }
                      _y2 = script.getNumberValue('Y2', script);
                      _y2 = Math.round(_y2);
                      if (_y2 < 0) {
                        _y2 = 0;
                      } else if (_y2 > 64) {
                        _y2 = 64;
                      }
                      _x3 = script.getNumberValue('X3', script);
                      _x3 = Math.round(_x3);
                      if (_x3 < 0) {
                        _x3 = 0;
                      } else if (_x3 > 128) {
                        _x3 = 128;
                      }
                      _y3 = script.getNumberValue('Y3', script);
                      _y3 = Math.round(_y3);
                      if (_y3 < 0) {
                        _y3 = 0;
                      } else if (_y3 > 64) {
                        _y3 = 64;
                      }
                      _isFill = script.getNumberValue('ISFILL', script);
                      _color = script.getNumberValue('COLOR', script);
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 23,
                          params: [_x1, _y1, _x2, _y2, _x3, _y3, _isFill, _color]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context32.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context32.stop();
                  }
                }, _callee32);
              }))();
            }
          },
          CodeWizLite_OLED_printHG: {
            // OLED 한글 출력
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Dropdown',
              options: [['❌', '0'], ['⭕', '1']],
              value: '1',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: ['코드위즈 Magic!!', null],
              type: 'CodeWizLite_OLED_printHG'
            },
            paramsKeyMap: {
              TEXT: 0,
              isLB: 1
            },
            "class": 'CodeWizLite_OLED',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee33() {
                var _value, _isLB, order, id;
                return _regenerator["default"].wrap(function (_context33) {
                  while (1) switch (_context33.prev = _context33.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context33.next = 1;
                        break;
                      }
                      _context33.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _value = script.getStringValue('TEXT');
                      _isLB = script.getNumberValue('isLB', script);
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 42,
                          params: [_value, _isLB]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context33.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context33.stop();
                  }
                }, _callee33);
              }))();
            }
          },
          CodeWizLite_DIGITAL_OUTPUT_title: {
            skeleton: 'basic_text',
            skeletonOptions: {
              box: {
                offsetX: this.getOffsetX(Lang.template.CodeWizLite_DIGITAL_OUTPUT_title),
                offsetY: 5
              }
            },
            color: EntryStatic.colorSet.common.TRANSPARENT,
            fontColor: '#333333',
            params: [{
              type: 'Text',
              text: Lang.template.CodeWizLite_DIGITAL_OUTPUT_title,
              color: '#333333',
              align: 'left'
            }],
            def: {
              type: 'CodeWizLite_DIGITAL_OUTPUT_title'
            },
            "class": 'CodeWizLite_DIGITAL_OUTPUT',
            isNotFor: ['CodeWizLite'],
            events: {}
          },
          CodeWizLite_DIGITAL_OUTPUT_digitalWrite: {
            // Block UI : "터치센서 디지털 %1(으)로 %2내보내기%3",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [['13', '13'], ['14', '14'], ['15', '15'], ['27', '27'], ['32', '32'], ['33', '33'], ['18', '18'], ['19', '19']],
              value: '13',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Dropdown',
              options: [['LOW', '0'], ['HIGH', '1']],
              value: '1',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null, null],
              type: 'CodeWizLite_DIGITAL_OUTPUT_digitalWrite'
            },
            paramsKeyMap: {
              PIN: 0,
              VALUE: 1
            },
            "class": 'CodeWizLite_DIGITAL_OUTPUT',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee34() {
                var _pin, _val, order, id;
                return _regenerator["default"].wrap(function (_context34) {
                  while (1) switch (_context34.prev = _context34.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context34.next = 1;
                        break;
                      }
                      _context34.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _pin = script.getNumberValue('PIN', script);
                      _val = script.getNumberValue('VALUE', script);
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 25,
                          params: [_pin, _val]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context34.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context34.stop();
                  }
                }, _callee34);
              }))();
            }
          },
          CodeWizLite_DIGITAL_OUTPUT_pwmWrite: {
            // Block UI : "터치센서 PWM %1(으)로 %2내보내기(0~1023)%3",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [['13', '13'], ['14', '14'], ['15', '15'], ['27', '27'], ['32', '32'], ['33', '33'], ['18', '18'], ['19', '19']],
              value: '13',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null, '0'],
              type: 'CodeWizLite_DIGITAL_OUTPUT_pwmWrite'
            },
            paramsKeyMap: {
              PIN: 0,
              VALUE: 1
            },
            "class": 'CodeWizLite_DIGITAL_OUTPUT',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee35() {
                var _pin, _val, order, id;
                return _regenerator["default"].wrap(function (_context35) {
                  while (1) switch (_context35.prev = _context35.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context35.next = 1;
                        break;
                      }
                      _context35.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _pin = script.getNumberValue('PIN', script);
                      _val = script.getNumberValue('VALUE', script);
                      _val = Math.round(_val);
                      if (_val < 0) {
                        _val = 0;
                      } else if (_val > 1023) {
                        _val = 1023;
                      }
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 26,
                          params: [_pin, _val]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context35.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context35.stop();
                  }
                }, _callee35);
              }))();
            }
          },
          /////////오즈아이 시작//////////////////////////////////////////////////////////////////////////////////////////////

          CodeWizLite_OzEye_title: {
            skeleton: 'basic_text',
            skeletonOptions: {
              box: {
                offsetX: this.getOffsetX(Lang.template.CodeWizLite_OzEye_title),
                offsetY: 5
              }
            },
            color: EntryStatic.colorSet.common.TRANSPARENT,
            fontColor: '#333333',
            params: [{
              type: 'Text',
              text: Lang.template.CodeWizLite_OzEye_title,
              color: '#333333',
              align: 'left'
            }],
            def: {
              type: 'CodeWizLite_OzEye_title'
            },
            "class": 'CodeWizLite_OzEye',
            isNotFor: ['CodeWizLite'],
            events: {}
          },
          CodeWizLite_OzEye_initOzEye: {
            // Block UI : '오즈아이 시작설정%1',
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null],
              type: 'CodeWizLite_OzEye_initOzEye'
            },
            paramsKeyMap: {},
            "class": 'CodeWizLite_OzEye',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee36() {
                var order, id;
                return _regenerator["default"].wrap(function (_context36) {
                  while (1) switch (_context36.prev = _context36.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context36.next = 1;
                        break;
                      }
                      _context36.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 52,
                          params: []
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context36.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context36.stop();
                  }
                }, _callee36);
              }))();
            }
          },
          CodeWizLite_OzEye_setModeOfOzEye: {
            // Block UI : '오즈아이 %1알고리즘으로 설정%2'
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [['1.선 인식', '3'], ['2.색 인식', '4'], ['3.태그 인식', '5'], ['4.이미지 인식', '6'], ['5.사물 인식', '2'], ['6.사물 추적', '1'], ['7.선 + 태그', '7'], ['8.얼굴 인식', '0'], ['9.숫자 인식', '8']],
              value: '2',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null],
              type: 'CodeWizLite_OzEye_setModeOfOzEye'
            },
            paramsKeyMap: {
              MODE: 0
            },
            "class": 'CodeWizLite_OzEye',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee37() {
                var mode, order, id;
                return _regenerator["default"].wrap(function (_context37) {
                  while (1) switch (_context37.prev = _context37.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context37.next = 1;
                        break;
                      }
                      _context37.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      mode = script.getNumberValue('MODE', script);
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 53,
                          params: [mode]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context37.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context37.stop();
                  }
                }, _callee37);
              }))();
            }
          },
          CodeWizLite_OzEye_readOzEye: {
            // Block UI : "오즈아이 데이터 요청시작%1",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [],
              type: 'CodeWizLite_OzEye_readOzEye'
            },
            paramsKeyMap: {},
            "class": 'CodeWizLite_OzEye',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee38() {
                var order, id;
                return _regenerator["default"].wrap(function (_context38) {
                  while (1) switch (_context38.prev = _context38.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context38.next = 1;
                        break;
                      }
                      _context38.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 54,
                          params: []
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context38.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context38.stop();
                  }
                }, _callee38);
              }))();
            }
          },
          CodeWizLite_OzEye_isLearnedOzEye: {
            // Block UI : "오즈아이 ID가%1인 데이터를 학습했는가?%2",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_boolean_field',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [1, null],
              type: 'CodeWizLite_OzEye_isLearnedOzEye'
            },
            paramsKeyMap: {
              ID: 0
            },
            "class": 'CodeWizLite_OzEye',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee39() {
                var _Entry$CodeWizLite$se2, _Entry$CodeWizLite$se3;
                var learnId, order, id, retVal;
                return _regenerator["default"].wrap(function (_context39) {
                  while (1) switch (_context39.prev = _context39.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context39.next = 1;
                        break;
                      }
                      _context39.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      learnId = script.getNumberValue('ID', script);
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.READ,
                        value: {
                          opcode: 15,
                          params: [learnId]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context39.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                      retVal = (_Entry$CodeWizLite$se2 = (_Entry$CodeWizLite$se3 = Entry.CodeWizLite.sensorData[id]) === null || _Entry$CodeWizLite$se3 === void 0 ? void 0 : _Entry$CodeWizLite$se3.value) !== null && _Entry$CodeWizLite$se2 !== void 0 ? _Entry$CodeWizLite$se2 : false; //delete Entry.CodeWizLite.sensorData[id];
                      return _context39.abrupt("return", retVal);
                    case 3:
                    case "end":
                      return _context39.stop();
                  }
                }, _callee39);
              }))();
            }
          },
          CodeWizLite_OzEye_isContainOzEye: {
            // Block UI : "오즈아이 ID:%1로 인식한 %2데이터가 있는가?%3",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_boolean_field',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Dropdown',
              options: [['사각형', '42'], ['화살표', '43']],
              value: '42',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [1, null, null],
              type: 'CodeWizLite_OzEye_isContainOzEye'
            },
            paramsKeyMap: {
              ID: 0,
              TYPE: 1
            },
            "class": 'CodeWizLite_OzEye',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              var _learnId = script.getNumberValue('ID', script);
              var _type = script.getNumberValue('TYPE', script);
              // console.log(this.sensorData);
              // console.log(Entry.CodeWizLite.sensorData.HUSKY_READ);
              var huskyData = Entry.CodeWizLite.sensorData.HUSKY_READ;
              if (!huskyData._list || huskyData._list.length === 0) {
                return false;
              }
              if ((huskyData === null || huskyData === void 0 ? void 0 : huskyData._type) !== _type) {
                return false;
              }
              var _list = Entry.CodeWizLite.sensorData.HUSKY_READ._list;
              for (var i = 0; i < _list.length; ++i) {
                if (_list[i][0] === _learnId) {
                  return true;
                }
              }
              return false;
            } // async func(sprite, script) {
            //     if (Entry.CodeWizLite.intervalId) {
            //         await Entry.CodeWizLite.preWait();
            //     }
            //     let _learnId = script.getNumberValue('ID', script);
            //     let _type = script.getNumberValue('TYPE', script);
            //     const order = {
            //         type: Entry.CodeWizLite.sensorTypes.READ,
            //         value: {
            //             opcode: 2,
            //             params: [_learnId, _type],
            //         },
            //     };
            //     const id = Entry.CodeWizLite.sendOrder(order);
            //     await Entry.CodeWizLite.checkComplete(1000, id);
            //     let retVal= Entry.CodeWizLite.sensorData[id]?.value ?? false;
            //     //delete Entry.CodeWizLite.sensorData[id];
            //     return retVal;
            // },
          },
          CodeWizLite_OzEye_getCountLearnedOzEye: {
            // Block UI : "오즈아이가 감지한 학습데이터 수%1",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_string_field',
            statements: [],
            params: [{
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null],
              type: 'CodeWizLite_OzEye_getCountLearnedOzEye'
            },
            paramsKeyMap: {},
            "class": 'CodeWizLite_OzEye',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              var _Entry$CodeWizLite$se4, _Entry$CodeWizLite$se5;
              return (_Entry$CodeWizLite$se4 = (_Entry$CodeWizLite$se5 = Entry.CodeWizLite.sensorData.HUSKY_READ) === null || _Entry$CodeWizLite$se5 === void 0 ? void 0 : _Entry$CodeWizLite$se5._count) !== null && _Entry$CodeWizLite$se4 !== void 0 ? _Entry$CodeWizLite$se4 : 0;
            } // async func(sprite, script) {
            //     if (Entry.CodeWizLite.intervalId) {
            //         await Entry.CodeWizLite.preWait();
            //     }
            //     const order = {
            //         type: Entry.CodeWizLite.sensorTypes.READ,
            //         value: {
            //             opcode: 3,
            //             params: [],
            //         },
            //     };
            //     const id = Entry.CodeWizLite.sendOrder(order);
            //     await Entry.CodeWizLite.checkComplete(1000, id);
            //     let retVal= Entry.CodeWizLite.sensorData[id]?.value ?? 0;
            //     //delete Entry.CodeWizLite.sensorData[id];
            //     return retVal;
            // },
          },
          CodeWizLite_OzEye_hasTypeOzEye: {
            // Block UI : "오즈아이가 읽은 데이터 타입이%1인가?%2",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_boolean_field',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [['사각형', '42'], ['화살표', '43']],
              value: '42',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null],
              type: 'CodeWizLite_OzEye_hasTypeOzEye'
            },
            paramsKeyMap: {
              TYPE: 0
            },
            "class": 'CodeWizLite_OzEye',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              var _Entry$CodeWizLite$se6;
              var _type = script.getNumberValue('TYPE', script);
              return ((_Entry$CodeWizLite$se6 = Entry.CodeWizLite.sensorData.HUSKY_READ) === null || _Entry$CodeWizLite$se6 === void 0 ? void 0 : _Entry$CodeWizLite$se6._type) === _type;
            } // async func(sprite, script) {
            //     if (Entry.CodeWizLite.intervalId) {
            //         await Entry.CodeWizLite.preWait();
            //     }
            //     let _type = script.getNumberValue('TYPE', script);
            //     const order = {
            //         type: Entry.CodeWizLite.sensorTypes.READ,
            //         value: {
            //             opcode: 4,
            //             params: [_type],
            //         },
            //     };
            //     const id = Entry.CodeWizLite.sendOrder(order);
            //     await Entry.CodeWizLite.checkComplete(1000, id);
            //     let retVal= Entry.CodeWizLite.sensorData[id]?.value ?? false;
            //     //delete Entry.CodeWizLite.sensorData[id];
            //     return retVal
            // },
          },
          CodeWizLite_OzEye_getArrowInfoOzEye: {
            // Block UI : "오즈아이가 읽은 ID%1인 화살표정보%2%3",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_string_field',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Dropdown',
              options: [['시작 X좌표', '1'], ['시작 Y좌표', '2'], ['종료 X좌표', '3'], ['종료 Y좌표', '4']],
              value: '1',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [1, null],
              type: 'CodeWizLite_OzEye_getArrowInfoOzEye'
            },
            paramsKeyMap: {
              ID: 0,
              TYPE: 1
            },
            "class": 'CodeWizLite_OzEye',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              var _id = script.getNumberValue('ID', script);
              var _arrowType = script.getNumberValue('TYPE', script);
              var huskyData = Entry.CodeWizLite.sensorData.HUSKY_READ;
              if (!huskyData._list || huskyData._list.length === 0) {
                return -1;
              }
              if ((huskyData === null || huskyData === void 0 ? void 0 : huskyData._type) !== 43) {
                return -1;
              }
              for (var i = 0; i < huskyData._list.length; ++i) {
                if (huskyData._list[i][0] === _id) {
                  return huskyData._list[i][_arrowType];
                }
              }
              return -1;
            } // async func(sprite, script) {
            //     if (Entry.CodeWizLite.intervalId) {
            //         await Entry.CodeWizLite.preWait();
            //     }
            //     let _arrowType = script.getNumberValue('TYPE', script);
            //     const order = {
            //         type: Entry.CodeWizLite.sensorTypes.READ,
            //         value: {
            //             opcode: 5,
            //             params: [_arrowType],
            //         },
            //     };
            //     const id = Entry.CodeWizLite.sendOrder(order);
            //     await Entry.CodeWizLite.checkComplete(1000, id);
            //     let retVal= Entry.CodeWizLite.sensorData[id]?.value ?? 0;
            //     //delete Entry.CodeWizLite.sensorData[id];
            //     return retVal
            // },
          },
          CodeWizLite_OzEye_getBoxInfoOzEye2: {
            // Block UI : "오즈아이가 읽은 ID%1인 사각형정보%2%3",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_string_field',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Dropdown',
              options: [['중심 X좌표', '1'], ['중심 Y좌표', '2'], ['너비', '3'], ['높이', '4']],
              value: '1',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [1, null],
              type: 'CodeWizLite_OzEye_getBoxInfoOzEye2'
            },
            paramsKeyMap: {
              ID: 0,
              TYPE: 1
            },
            "class": 'CodeWizLite_OzEye',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              var _id = script.getNumberValue('ID', script);
              var _boxType = script.getNumberValue('TYPE', script);
              var huskyData = Entry.CodeWizLite.sensorData.HUSKY_READ;
              if (!huskyData._list || huskyData._list.length === 0) {
                return -1;
              }
              if ((huskyData === null || huskyData === void 0 ? void 0 : huskyData._type) !== 42) {
                return -1;
              }
              for (var i = 0; i < huskyData._list.length; ++i) {
                if (huskyData._list[i][0] === _id) {
                  return huskyData._list[i][_boxType];
                }
              }
              return -1;
            }
          },
          CodeWizLite_OzEye_getBoxInfoOzEye: {
            // Block UI : "오즈아이가 읽은 사각형정보%1(중심좌표가 중앙에 가장 가까운 것)%2",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_string_field',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [['ID', '0'], ['중심 X좌표', '1'], ['중심 Y좌표', '2'], ['너비', '3'], ['높이', '4']],
              value: '0',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null],
              type: 'CodeWizLite_OzEye_getBoxInfoOzEye'
            },
            paramsKeyMap: {
              TYPE: 0
            },
            "class": 'CodeWizLite_OzEye',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              var _boxType = script.getNumberValue('TYPE', script);
              var huskyData = Entry.CodeWizLite.sensorData.HUSKY_READ;
              if (!huskyData._list || huskyData._list.length === 0) {
                return -1;
              }
              if ((huskyData === null || huskyData === void 0 ? void 0 : huskyData._type) !== 42 || (huskyData === null || huskyData === void 0 ? void 0 : huskyData._count) === 0) {
                return -1;
              }
              var curIdx = 0;
              var dist = Entry.CodeWizLite.HUSKY.getDist(huskyData._list[0][0], huskyData._list[0][1]);
              var curDist;
              for (var i = 1; i < huskyData._count; ++i) {
                curDist = Entry.CodeWizLite.HUSKY.getDist(huskyData._list[i][0], huskyData._list[i][1]);
                if (dist > curDist) {
                  dist = curDist;
                  curIdx = i;
                }
              }
              return huskyData._list[curIdx][_boxType];
            } // async func(sprite, script) {
            //     if (Entry.CodeWizLite.intervalId) {
            //         await Entry.CodeWizLite.preWait();
            //     }
            //     let _boxType = script.getNumberValue('TYPE', script);
            //     const order = {
            //         type: Entry.CodeWizLite.sensorTypes.READ,
            //         value: {
            //             opcode: 6,
            //             params: [_boxType],
            //         },
            //     };
            //     const id = Entry.CodeWizLite.sendOrder(order);
            //     await Entry.CodeWizLite.checkComplete(1000, id);
            //     let retVal= Entry.CodeWizLite.sensorData[id]?.value ?? 0;
            //     //delete Entry.CodeWizLite.sensorData[id];
            //     return retVal
            // },
          },
          //오즈아이에 텍스트 출력하기 기능 이후 적용
          /*
          CodeWizLite_OzEye_writeTextOzEye: {
              // Block UI : "오즈아이 x:%1 y:%2에 %3출력%4",
              color: EntryStatic.colorSet.block.default.HARDWARE,
              outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
              skeleton: 'basic',
              statements: [],
              params: [
                  {
                      type: 'Block',
                      accept: 'string',
                  },
                  {
                      type: 'Block',
                      accept: 'string',
                  },
                  {
                      type: 'Block',
                      accept: 'string',
                  },
                  {
                      type: 'Indicator',
                      img: 'block_icon/hardware_icon.svg',
                      size: 12,
                  },
              ],
              events: {},
              def: {
                  params: [0, 0, 'CodeWizLite'],
                  type: 'CodeWizLite_OzEye_writeTextOzEye',
              },
              paramsKeyMap: {
                  X: 0,
                  Y: 1,
                  TEXT: 2,
              },
              class: 'CodeWizLite_OzEye',
              isNotFor: ['CodeWizLite'],
              async func(sprite, script) {
                  if (Entry.CodeWizLite.intervalId) {
                      await Entry.CodeWizLite.preWait();
                  }
                  let _x = script.getNumberValue('X', script);
                  let _y = script.getNumberValue('Y', script);
                  let _text = script.getStringValue('TEXT');
                   const order = {
                      type: Entry.CodeWizLite.sensorTypes.WRITE,
                      value: {
                          opcode: 55,
                          params: [_x, _y, _text],
                      },
                  };
                  const id = Entry.CodeWizLite.sendOrder(order);
                  await Entry.CodeWizLite.checkComplete(1000, id);
                  //delete Entry.CodeWizLite.sensorData[id];
              },
          },
          CodeWizLite_OzEye_clearTextOzEye: {
              // Block UI : "오즈아이 텍스트 지우기%1",
              color: EntryStatic.colorSet.block.default.HARDWARE,
              outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
              skeleton: 'basic',
              statements: [],
              params: [
                  {
                      type: 'Indicator',
                      img: 'block_icon/hardware_icon.svg',
                      size: 12,
                  },
              ],
              events: {},
              def: {
                  params: [],
                  type: 'CodeWizLite_OzEye_clearTextOzEye',
              },
              paramsKeyMap: {},
              class: 'CodeWizLite_OzEye',
              isNotFor: ['CodeWizLite'],
              async func(sprite, script) {
                  if (Entry.CodeWizLite.intervalId) {
                      await Entry.CodeWizLite.preWait();
                  }
                   const order = {
                      type: Entry.CodeWizLite.sensorTypes.WRITE,
                      value: {
                          opcode: 56,
                          params: [],
                      },
                  };
                  const id = Entry.CodeWizLite.sendOrder(order);
                  await Entry.CodeWizLite.checkComplete(1000, id);
                  //delete Entry.CodeWizLite.sensorData[id];
              },
          },
          */

          CodeWizLite_OzEye_setLightLevel: {
            // Block UI : '오즈아이 라이트 밝기를 %1 단계로 설정(1~7)%2',
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [['1', '1'], ['2', '2'], ['3', '3'], ['4', '4'], ['5', '5'], ['6', '6'], ['7', '7']],
              value: '1',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null],
              type: 'CodeWizLite_OzEye_setLightLevel'
            },
            paramsKeyMap: {
              Level: 0
            },
            "class": 'CodeWizLite_OzEye',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee40() {
                var Level, order, id;
                return _regenerator["default"].wrap(function (_context40) {
                  while (1) switch (_context40.prev = _context40.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context40.next = 1;
                        break;
                      }
                      _context40.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      Level = script.getNumberValue('Level', script);
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 57,
                          params: [Level]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context40.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context40.stop();
                  }
                }, _callee40);
              }))();
            }
          },
          CodeWizLite_OzEye_LightOff: {
            // Block UI : '오즈아이 라이트 끄기%1',
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null],
              type: 'CodeWizLite_OzEye_LightOff'
            },
            paramsKeyMap: {},
            "class": 'CodeWizLite_OzEye',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee41() {
                var order, id;
                return _regenerator["default"].wrap(function (_context41) {
                  while (1) switch (_context41.prev = _context41.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context41.next = 1;
                        break;
                      }
                      _context41.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 58,
                          params: []
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context41.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context41.stop();
                  }
                }, _callee41);
              }))();
            }
          },
          //////////오즈아이 끝/////////////////////////////////////////////////////////////////////////////////////////////

          CodeWizLite_HuskyLens_title: {
            skeleton: 'basic_text',
            skeletonOptions: {
              box: {
                offsetX: this.getOffsetX(Lang.template.CodeWizLite_HuskyLens_title),
                offsetY: 5
              }
            },
            color: EntryStatic.colorSet.common.TRANSPARENT,
            fontColor: '#333333',
            params: [{
              type: 'Text',
              text: Lang.template.CodeWizLite_HuskyLens_title,
              color: '#333333',
              align: 'left'
            }],
            def: {
              type: 'CodeWizLite_HuskyLens_title'
            },
            "class": 'CodeWizLite_HuskyLens',
            isNotFor: ['CodeWizLite'],
            events: {}
          },
          CodeWizLite_HuskyLens_initHuskyLens: {
            // Block UI : '허스키렌즈 시작설정%1',
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null],
              type: 'CodeWizLite_HuskyLens_initHuskyLens'
            },
            paramsKeyMap: {},
            "class": 'CodeWizLite_HuskyLens',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee42() {
                var order, id;
                return _regenerator["default"].wrap(function (_context42) {
                  while (1) switch (_context42.prev = _context42.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context42.next = 1;
                        break;
                      }
                      _context42.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 27,
                          params: []
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context42.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context42.stop();
                  }
                }, _callee42);
              }))();
            }
          },
          CodeWizLite_HuskyLens_setModeOfHuskyLens: {
            // Block UI : '허스키렌즈 %1알고리즘으로 설정%2'
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [['1.FACE_RECOGNITION', '0'], ['2.OBJECT_TRACKING', '1'], ['3.OBJECT_RECOGNITION', '2'], ['4.LINE_TRACKING', '3'], ['5.COLOR_RECOGNITION', '4'], ['6.TAG_RECOGNITION', '5'], ['7.OBJECT_CLASSIFICATION', '6']],
              value: '2',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null],
              type: 'CodeWizLite_HuskyLens_setModeOfHuskyLens'
            },
            paramsKeyMap: {
              MODE: 0
            },
            "class": 'CodeWizLite_HuskyLens',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee43() {
                var mode, order, id;
                return _regenerator["default"].wrap(function (_context43) {
                  while (1) switch (_context43.prev = _context43.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context43.next = 1;
                        break;
                      }
                      _context43.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      mode = script.getNumberValue('MODE', script);
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 28,
                          params: [mode]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context43.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context43.stop();
                  }
                }, _callee43);
              }))();
            }
          },
          CodeWizLite_HuskyLens_readHuskyLens: {
            // Block UI : "허스키렌즈 데이터 요청시작%1",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [],
              type: 'CodeWizLite_HuskyLens_readHuskyLens'
            },
            paramsKeyMap: {},
            "class": 'CodeWizLite_HuskyLens',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee44() {
                var order, id;
                return _regenerator["default"].wrap(function (_context44) {
                  while (1) switch (_context44.prev = _context44.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context44.next = 1;
                        break;
                      }
                      _context44.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 29,
                          params: []
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context44.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context44.stop();
                  }
                }, _callee44);
              }))();
            }
          },
          CodeWizLite_HuskyLens_isLearnedHuskyLens: {
            // Block UI : "허스키렌즈 ID가%1인 데이터를 학습했는가?%2",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_boolean_field',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [1, null],
              type: 'CodeWizLite_HuskyLens_isLearnedHuskyLens'
            },
            paramsKeyMap: {
              ID: 0
            },
            "class": 'CodeWizLite_HuskyLens',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee45() {
                var _Entry$CodeWizLite$se7, _Entry$CodeWizLite$se8;
                var learnId, order, id, retVal;
                return _regenerator["default"].wrap(function (_context45) {
                  while (1) switch (_context45.prev = _context45.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context45.next = 1;
                        break;
                      }
                      _context45.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      learnId = script.getNumberValue('ID', script);
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.READ,
                        value: {
                          opcode: 1,
                          params: [learnId]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context45.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                      retVal = (_Entry$CodeWizLite$se7 = (_Entry$CodeWizLite$se8 = Entry.CodeWizLite.sensorData[id]) === null || _Entry$CodeWizLite$se8 === void 0 ? void 0 : _Entry$CodeWizLite$se8.value) !== null && _Entry$CodeWizLite$se7 !== void 0 ? _Entry$CodeWizLite$se7 : false; //delete Entry.CodeWizLite.sensorData[id];
                      return _context45.abrupt("return", retVal);
                    case 3:
                    case "end":
                      return _context45.stop();
                  }
                }, _callee45);
              }))();
            }
          },
          CodeWizLite_HuskyLens_isContainHuskyLens: {
            // Block UI : "허스키렌즈 ID:%1로 인식한 %2데이터가 있는가?%3",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_boolean_field',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Dropdown',
              options: [['사각형', '42'], ['화살표', '43']],
              value: '42',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [1, null, null],
              type: 'CodeWizLite_HuskyLens_isContainHuskyLens'
            },
            paramsKeyMap: {
              ID: 0,
              TYPE: 1
            },
            "class": 'CodeWizLite_HuskyLens',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              var _learnId = script.getNumberValue('ID', script);
              var _type = script.getNumberValue('TYPE', script);
              // console.log(this.sensorData);
              // console.log(Entry.CodeWizLite.sensorData.HUSKY_READ);
              var huskyData = Entry.CodeWizLite.sensorData.HUSKY_READ;
              if (!huskyData._list || huskyData._list.length === 0) {
                return false;
              }
              if ((huskyData === null || huskyData === void 0 ? void 0 : huskyData._type) !== _type) {
                return false;
              }
              var _list = Entry.CodeWizLite.sensorData.HUSKY_READ._list;
              for (var i = 0; i < _list.length; ++i) {
                if (_list[i][0] === _learnId) {
                  return true;
                }
              }
              return false;
            } // async func(sprite, script) {
            //     if (Entry.CodeWizLite.intervalId) {
            //         await Entry.CodeWizLite.preWait();
            //     }
            //     let _learnId = script.getNumberValue('ID', script);
            //     let _type = script.getNumberValue('TYPE', script);
            //     const order = {
            //         type: Entry.CodeWizLite.sensorTypes.READ,
            //         value: {
            //             opcode: 2,
            //             params: [_learnId, _type],
            //         },
            //     };
            //     const id = Entry.CodeWizLite.sendOrder(order);
            //     await Entry.CodeWizLite.checkComplete(1000, id);
            //     let retVal= Entry.CodeWizLite.sensorData[id]?.value ?? false;
            //     //delete Entry.CodeWizLite.sensorData[id];
            //     return retVal;
            // },
          },
          CodeWizLite_HuskyLens_getCountLearnedHuskyLens: {
            // Block UI : "허스키렌즈가 감지한 학습데이터 수%1",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_string_field',
            statements: [],
            params: [{
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null],
              type: 'CodeWizLite_HuskyLens_getCountLearnedHuskyLens'
            },
            paramsKeyMap: {},
            "class": 'CodeWizLite_HuskyLens',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              var _Entry$CodeWizLite$se9, _Entry$CodeWizLite$se0;
              return (_Entry$CodeWizLite$se9 = (_Entry$CodeWizLite$se0 = Entry.CodeWizLite.sensorData.HUSKY_READ) === null || _Entry$CodeWizLite$se0 === void 0 ? void 0 : _Entry$CodeWizLite$se0._count) !== null && _Entry$CodeWizLite$se9 !== void 0 ? _Entry$CodeWizLite$se9 : 0;
            } // async func(sprite, script) {
            //     if (Entry.CodeWizLite.intervalId) {
            //         await Entry.CodeWizLite.preWait();
            //     }
            //     const order = {
            //         type: Entry.CodeWizLite.sensorTypes.READ,
            //         value: {
            //             opcode: 3,
            //             params: [],
            //         },
            //     };
            //     const id = Entry.CodeWizLite.sendOrder(order);
            //     await Entry.CodeWizLite.checkComplete(1000, id);
            //     let retVal= Entry.CodeWizLite.sensorData[id]?.value ?? 0;
            //     //delete Entry.CodeWizLite.sensorData[id];
            //     return retVal;
            // },
          },
          CodeWizLite_HuskyLens_hasTypeHuskyLens: {
            // Block UI : "허스키렌즈가 읽은 데이터 타입이%1인가?%2",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_boolean_field',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [['사각형', '42'], ['화살표', '43']],
              value: '42',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null],
              type: 'CodeWizLite_HuskyLens_hasTypeHuskyLens'
            },
            paramsKeyMap: {
              TYPE: 0
            },
            "class": 'CodeWizLite_HuskyLens',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              var _Entry$CodeWizLite$se1;
              var _type = script.getNumberValue('TYPE', script);
              return ((_Entry$CodeWizLite$se1 = Entry.CodeWizLite.sensorData.HUSKY_READ) === null || _Entry$CodeWizLite$se1 === void 0 ? void 0 : _Entry$CodeWizLite$se1._type) === _type;
            } // async func(sprite, script) {
            //     if (Entry.CodeWizLite.intervalId) {
            //         await Entry.CodeWizLite.preWait();
            //     }
            //     let _type = script.getNumberValue('TYPE', script);
            //     const order = {
            //         type: Entry.CodeWizLite.sensorTypes.READ,
            //         value: {
            //             opcode: 4,
            //             params: [_type],
            //         },
            //     };
            //     const id = Entry.CodeWizLite.sendOrder(order);
            //     await Entry.CodeWizLite.checkComplete(1000, id);
            //     let retVal= Entry.CodeWizLite.sensorData[id]?.value ?? false;
            //     //delete Entry.CodeWizLite.sensorData[id];
            //     return retVal
            // },
          },
          CodeWizLite_HuskyLens_getArrowInfoHuskyLens: {
            // Block UI : "허스키렌즈가 읽은 ID%1인 화살표정보%2%3",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_string_field',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Dropdown',
              options: [['시작 X좌표', '1'], ['시작 Y좌표', '2'], ['종료 X좌표', '3'], ['종료 Y좌표', '4']],
              value: '1',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [1, null],
              type: 'CodeWizLite_HuskyLens_getArrowInfoHuskyLens'
            },
            paramsKeyMap: {
              ID: 0,
              TYPE: 1
            },
            "class": 'CodeWizLite_HuskyLens',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              var _id = script.getNumberValue('ID', script);
              var _arrowType = script.getNumberValue('TYPE', script);
              var huskyData = Entry.CodeWizLite.sensorData.HUSKY_READ;
              if (!huskyData._list || huskyData._list.length === 0) {
                return -1;
              }
              if ((huskyData === null || huskyData === void 0 ? void 0 : huskyData._type) !== 43) {
                return -1;
              }
              for (var i = 0; i < huskyData._list.length; ++i) {
                if (huskyData._list[i][0] === _id) {
                  return huskyData._list[i][_arrowType];
                }
              }
              return -1;
            } // async func(sprite, script) {
            //     if (Entry.CodeWizLite.intervalId) {
            //         await Entry.CodeWizLite.preWait();
            //     }
            //     let _arrowType = script.getNumberValue('TYPE', script);
            //     const order = {
            //         type: Entry.CodeWizLite.sensorTypes.READ,
            //         value: {
            //             opcode: 5,
            //             params: [_arrowType],
            //         },
            //     };
            //     const id = Entry.CodeWizLite.sendOrder(order);
            //     await Entry.CodeWizLite.checkComplete(1000, id);
            //     let retVal= Entry.CodeWizLite.sensorData[id]?.value ?? 0;
            //     //delete Entry.CodeWizLite.sensorData[id];
            //     return retVal
            // },
          },
          CodeWizLite_HuskyLens_getBoxInfoHuskyLens2: {
            // Block UI : "허스키렌즈가 읽은 ID%1인 사각형정보%2%3",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_string_field',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Dropdown',
              options: [['중심 X좌표', '1'], ['중심 Y좌표', '2'], ['너비', '3'], ['높이', '4']],
              value: '1',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [1, null],
              type: 'CodeWizLite_HuskyLens_getBoxInfoHuskyLens2'
            },
            paramsKeyMap: {
              ID: 0,
              TYPE: 1
            },
            "class": 'CodeWizLite_HuskyLens',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              var _id = script.getNumberValue('ID', script);
              var _boxType = script.getNumberValue('TYPE', script);
              var huskyData = Entry.CodeWizLite.sensorData.HUSKY_READ;
              if (!huskyData._list || huskyData._list.length === 0) {
                return -1;
              }
              if ((huskyData === null || huskyData === void 0 ? void 0 : huskyData._type) !== 42) {
                return -1;
              }
              for (var i = 0; i < huskyData._list.length; ++i) {
                if (huskyData._list[i][0] === _id) {
                  return huskyData._list[i][_boxType];
                }
              }
              return -1;
            }
          },
          CodeWizLite_HuskyLens_getBoxInfoHuskyLens: {
            // Block UI : "허스키렌즈가 읽은 사각형정보%1(중심좌표가 중앙에 가장 가까운 것)%2",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_string_field',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [['ID', '0'], ['중심 X좌표', '1'], ['중심 Y좌표', '2'], ['너비', '3'], ['높이', '4']],
              value: '0',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null],
              type: 'CodeWizLite_HuskyLens_getBoxInfoHuskyLens'
            },
            paramsKeyMap: {
              TYPE: 0
            },
            "class": 'CodeWizLite_HuskyLens',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              var _boxType = script.getNumberValue('TYPE', script);
              var huskyData = Entry.CodeWizLite.sensorData.HUSKY_READ;
              if (!huskyData._list || huskyData._list.length === 0) {
                return -1;
              }
              if ((huskyData === null || huskyData === void 0 ? void 0 : huskyData._type) !== 42 || (huskyData === null || huskyData === void 0 ? void 0 : huskyData._count) === 0) {
                return -1;
              }
              var curIdx = 0;
              var dist = Entry.CodeWizLite.HUSKY.getDist(huskyData._list[0][0], huskyData._list[0][1]);
              var curDist;
              for (var i = 1; i < huskyData._count; ++i) {
                curDist = Entry.CodeWizLite.HUSKY.getDist(huskyData._list[i][0], huskyData._list[i][1]);
                if (dist > curDist) {
                  dist = curDist;
                  curIdx = i;
                }
              }
              return huskyData._list[curIdx][_boxType];
            } // async func(sprite, script) {
            //     if (Entry.CodeWizLite.intervalId) {
            //         await Entry.CodeWizLite.preWait();
            //     }
            //     let _boxType = script.getNumberValue('TYPE', script);
            //     const order = {
            //         type: Entry.CodeWizLite.sensorTypes.READ,
            //         value: {
            //             opcode: 6,
            //             params: [_boxType],
            //         },
            //     };
            //     const id = Entry.CodeWizLite.sendOrder(order);
            //     await Entry.CodeWizLite.checkComplete(1000, id);
            //     let retVal= Entry.CodeWizLite.sensorData[id]?.value ?? 0;
            //     //delete Entry.CodeWizLite.sensorData[id];
            //     return retVal
            // },
          },
          CodeWizLite_HuskyLens_writeTextHuskyLens: {
            // Block UI : "허스키렌즈 x:%1 y:%2에 %3출력%4",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [0, 0, 'CodeWizLite'],
              type: 'CodeWizLite_HuskyLens_writeTextHuskyLens'
            },
            paramsKeyMap: {
              X: 0,
              Y: 1,
              TEXT: 2
            },
            "class": 'CodeWizLite_HuskyLens',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee46() {
                var _x, _y, _text, order, id;
                return _regenerator["default"].wrap(function (_context46) {
                  while (1) switch (_context46.prev = _context46.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context46.next = 1;
                        break;
                      }
                      _context46.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _x = script.getNumberValue('X', script);
                      _y = script.getNumberValue('Y', script);
                      _text = script.getStringValue('TEXT');
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 30,
                          params: [_x, _y, _text]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context46.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context46.stop();
                  }
                }, _callee46);
              }))();
            }
          },
          CodeWizLite_HuskyLens_clearTextHuskyLens: {
            // Block UI : "허스키렌즈 텍스트 지우기%1",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [],
              type: 'CodeWizLite_HuskyLens_clearTextHuskyLens'
            },
            paramsKeyMap: {},
            "class": 'CodeWizLite_HuskyLens',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee47() {
                var order, id;
                return _regenerator["default"].wrap(function (_context47) {
                  while (1) switch (_context47.prev = _context47.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context47.next = 1;
                        break;
                      }
                      _context47.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 31,
                          params: []
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context47.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context47.stop();
                  }
                }, _callee47);
              }))();
            }
          },
          CodeWizLite_Servo_title: {
            skeleton: 'basic_text',
            skeletonOptions: {
              box: {
                offsetX: this.getOffsetX(Lang.template.CodeWizLite_Servo_title),
                offsetY: 5
              }
            },
            color: EntryStatic.colorSet.common.TRANSPARENT,
            fontColor: '#333333',
            params: [{
              type: 'Text',
              text: Lang.template.CodeWizLite_Servo_title,
              color: '#333333',
              align: 'left'
            }],
            def: {
              type: 'CodeWizLite_Servo_title'
            },
            "class": 'CodeWizLite_Servo',
            isNotFor: ['CodeWizLite'],
            events: {}
          },
          CodeWizLite_Servo_setAngle: {
            // Block UI : "서보모터(%1) 각도를 %2로 바꾸기%3",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [['SCON', '18.0'], ['MCON-18', '18.1'], ['MCON-19', '19'], ['MCON-15', '15'], ['MCON-27', '27']],
              value: '18.0',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null, '0'],
              type: 'CodeWizLite_Servo_setAngle'
            },
            paramsKeyMap: {
              PIN: 0,
              VALUE: 1
            },
            "class": 'CodeWizLite_Servo',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee48() {
                var _pin, _value, order, id;
                return _regenerator["default"].wrap(function (_context48) {
                  while (1) switch (_context48.prev = _context48.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context48.next = 1;
                        break;
                      }
                      _context48.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _pin = Number.parseInt(script.getNumberValue('PIN', script));
                      _value = Number.parseInt(script.getNumberValue('VALUE', script));
                      _value = Math.round(_value);
                      if (_value < 0) {
                        _value = 0;
                      } else if (_value > 180) {
                        _value = 180;
                      }
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 33,
                          params: [_pin, _value]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context48.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context48.stop();
                  }
                }, _callee48);
              }))();
            }
          },
          CodeWizLite_Servo_menuSpeed: {
            // Block UI : "무한회전 서보모터(%1) %2속도로 정하기%3",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [['SCON', '18.0'], ['MCON-18', '18.1'], ['MCON-19', '19'], ['MCON-15', '15'], ['MCON-27', '27']],
              value: '18.0',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Dropdown',
              options: [['빠른', '21'], ['보통', '39'], ['느린', '58'], ['멈춘', '76']],
              value: '21',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null, null],
              type: 'CodeWizLite_Servo_menuSpeed'
            },
            paramsKeyMap: {
              PIN: 0,
              VALUE: 1
            },
            "class": 'CodeWizLite_Servo',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee49() {
                var _pin, _value, order, id;
                return _regenerator["default"].wrap(function (_context49) {
                  while (1) switch (_context49.prev = _context49.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context49.next = 1;
                        break;
                      }
                      _context49.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _pin = Number.parseInt(script.getNumberValue('PIN', script));
                      _value = script.getNumberValue('VALUE', script);
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 34,
                          params: [_pin, _value]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context49.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context49.stop();
                  }
                }, _callee49);
              }))();
            }
          },
          CodeWizLite_Servo_customSpeed: {
            // Block UI : "무한회전 서보모터(%1) %2속도로 정하기(-100~100)%3",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [['SCON', '18.0'], ['MCON-18', '18.1'], ['MCON-19', '19'], ['MCON-15', '15'], ['MCON-27', '27']],
              value: '18.0',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null, '100'],
              type: 'CodeWizLite_Servo_customSpeed'
            },
            paramsKeyMap: {
              PIN: 0,
              VALUE: 1
            },
            "class": 'CodeWizLite_Servo',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee50() {
                var _pin, _value, order, id;
                return _regenerator["default"].wrap(function (_context50) {
                  while (1) switch (_context50.prev = _context50.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context50.next = 1;
                        break;
                      }
                      _context50.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _pin = Number.parseInt(script.getNumberValue('PIN', script));
                      _value = Number.parseInt(script.getNumberValue('VALUE', script));
                      if (_value < -100) {
                        _value = -100;
                      } else if (_value > 100) {
                        _value = 100;
                      }
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 35,
                          params: [_pin, _value]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context50.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context50.stop();
                  }
                }, _callee50);
              }))();
            }
          },
          CodeWizLite_Dc_title: {
            skeleton: 'basic_text',
            skeletonOptions: {
              box: {
                offsetX: this.getOffsetX(Lang.template.CodeWizLite_Dc_title),
                offsetY: 5
              }
            },
            color: EntryStatic.colorSet.common.TRANSPARENT,
            fontColor: '#333333',
            params: [{
              type: 'Text',
              text: Lang.template.CodeWizLite_Dc_title,
              color: '#333333',
              align: 'left'
            }],
            def: {
              type: 'CodeWizLite_Dc_title'
            },
            "class": 'CodeWizLite_Dc',
            isNotFor: ['CodeWizLite'],
            events: {}
          },
          CodeWizLite_Dc_setCarSpeed: {
            // Block UI : 'WizCar 모터에 %1,%2내보내기(-1000~1000)%3',
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: ['600', '600'],
              type: 'CodeWizLite_Dc_setCarSpeed'
            },
            paramsKeyMap: {
              L_VALUE: 0,
              R_VALUE: 1
            },
            "class": 'CodeWizLite_Dc',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee51() {
                var _lValue, _rValue, order, id;
                return _regenerator["default"].wrap(function (_context51) {
                  while (1) switch (_context51.prev = _context51.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context51.next = 1;
                        break;
                      }
                      _context51.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _lValue = Number.parseInt(script.getNumberValue('L_VALUE', script));
                      _rValue = Number.parseInt(script.getNumberValue('R_VALUE', script));
                      _lValue = Math.min(Math.max(-1000, _lValue), 1000);
                      _rValue = Math.min(Math.max(-1000, _rValue), 1000);
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 51,
                          params: [_lValue, _rValue]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context51.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context51.stop();
                  }
                }, _callee51);
              }))();
            }
          },
          CodeWizLite_Dc_setValue_Waterpump: {
            // 워터펌프
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [['MOTOR_L', '0'], ['MOTOR_R', '1']],
              value: '0',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null, '1023'],
              type: 'CodeWizLite_Dc_setValue_Waterpump'
            },
            paramsKeyMap: {
              PIN: 0,
              VALUE: 1
            },
            "class": 'CodeWizLite_Dc',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee52() {
                var _pin, _value, order, id;
                return _regenerator["default"].wrap(function (_context52) {
                  while (1) switch (_context52.prev = _context52.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context52.next = 1;
                        break;
                      }
                      _context52.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _pin = script.getNumberValue('PIN', script);
                      _value = Number.parseInt(script.getNumberValue('VALUE', script));
                      if (_value < 0) {
                        _value = 0;
                      } else if (_value > 1023) {
                        _value = 1023;
                      }
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 36,
                          params: [_pin, 1, _value]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context52.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context52.stop();
                  }
                }, _callee52);
              }))();
            }
          },
          CodeWizLite_DotMatrix_title: {
            skeleton: 'basic_text',
            skeletonOptions: {
              box: {
                offsetX: this.getOffsetX(Lang.template.CodeWizLite_DotMatrix_title),
                offsetY: 5
              }
            },
            color: EntryStatic.colorSet.common.TRANSPARENT,
            fontColor: '#333333',
            params: [{
              type: 'Text',
              text: Lang.template.CodeWizLite_DotMatrix_title,
              color: '#333333',
              align: 'left'
            }],
            def: {
              type: 'CodeWizLite_DotMatrix_title'
            },
            "class": 'CodeWizLite_DotMatrix',
            isNotFor: ['CodeWizLite'],
            events: {}
          },
          CodeWizLite_DotMatrix_init: {
            // Block UI : '도트매트릭스 %1개 DIN%2, CS%3, CLK%4에 시작설정%5',
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Dropdown',
              options: [['18', '18'], ['19', '19'], ['15', '15'], ['27', '27']],
              value: '18',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Dropdown',
              options: [['18', '18'], ['19', '19'], ['15', '15'], ['27', '27']],
              value: '19',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Dropdown',
              options: [['18', '18'], ['19', '19'], ['15', '15'], ['27', '27']],
              value: '15',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: ['1', null, null, null],
              type: 'CodeWizLite_DotMatrix_init'
            },
            paramsKeyMap: {
              COUNT: 0,
              PIN1: 1,
              PIN2: 2,
              PIN3: 3
            },
            "class": 'CodeWizLite_DotMatrix',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee53() {
                var _count, _pins, order, id;
                return _regenerator["default"].wrap(function (_context53) {
                  while (1) switch (_context53.prev = _context53.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context53.next = 1;
                        break;
                      }
                      _context53.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _count = Number.parseInt(script.getNumberValue('COUNT', script));
                      if (!(_count <= 0)) {
                        _context53.next = 2;
                        break;
                      }
                      return _context53.abrupt("return");
                    case 2:
                      if (_count > 8) {
                        _count = 8;
                      }
                    case 3:
                      _pins = [script.getNumberValue('PIN1', script), script.getNumberValue('PIN2', script), script.getNumberValue('PIN3', script)];
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 24,
                          params: [_count].concat(_pins)
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context53.next = 4;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 4:
                    case "end":
                      return _context53.stop();
                  }
                }, _callee53);
              }))();
            }
          },
          CodeWizLite_DotMatrix_setBrightness: {
            // Block UI : '도트매트릭스 %1번 밝기를 %2로 설정%3',
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: ['1', '8'],
              type: 'CodeWizLite_DotMatrix_setBrightness'
            },
            paramsKeyMap: {
              NUM: 0,
              BRIGHTNESS: 1
            },
            "class": 'CodeWizLite_DotMatrix',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee54() {
                var _num, _brightness, order, id;
                return _regenerator["default"].wrap(function (_context54) {
                  while (1) switch (_context54.prev = _context54.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context54.next = 1;
                        break;
                      }
                      _context54.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _num = Number.parseInt(script.getNumberValue('NUM', script));
                      if (_num < 1) {
                        num = 1;
                      } else if (_num > 8) {
                        _num = 8;
                      }
                      _brightness = Number.parseInt(script.getNumberValue('BRIGHTNESS', script));
                      if (_brightness < 1) {
                        _brightness = 1;
                      } else if (_brightness > 15) {
                        _brightness = 15;
                      }
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 37,
                          params: [_num, _brightness]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context54.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context54.stop();
                  }
                }, _callee54);
              }))();
            }
          },
          CodeWizLite_DotMatrix_printString: {
            // Block UI : '도트매트릭스 %1번에 문자열%2 출력%3',
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: ['1', 'HELLO'],
              type: 'CodeWizLite_DotMatrix_printString'
            },
            paramsKeyMap: {
              NUM: 0,
              TEXT: 1
            },
            "class": 'CodeWizLite_DotMatrix',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee55() {
                var _num, _value, order, id;
                return _regenerator["default"].wrap(function (_context55) {
                  while (1) switch (_context55.prev = _context55.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context55.next = 1;
                        break;
                      }
                      _context55.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _num = Number.parseInt(script.getNumberValue('NUM', script));
                      if (_num < 1) {
                        num = 1;
                      } else if (_num > 8) {
                        _num = 8;
                      }
                      _value = script.getStringValue('TEXT');
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 38,
                          params: [_num, _value]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context55.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context55.stop();
                  }
                }, _callee55);
              }))();
            }
          },
          CodeWizLite_DotMatrix_setLine: {
            // Block UI : '도트매트릭스 %1번에 %2번%3 %4로 만들기%5',
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Dropdown',
              options: [['행', '1'], ['열', '0']],
              value: '0',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: ['1', '2', null, '11111111'],
              type: 'CodeWizLite_DotMatrix_setLine'
            },
            paramsKeyMap: {
              NUM: 0,
              NUM_LINE: 1,
              IS_ROW: 2,
              VALUE: 3
            },
            "class": 'CodeWizLite_DotMatrix',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee56() {
                var _num, _numLine, _isRow, _value, _f, order, id;
                return _regenerator["default"].wrap(function (_context56) {
                  while (1) switch (_context56.prev = _context56.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context56.next = 1;
                        break;
                      }
                      _context56.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _num = Number.parseInt(script.getNumberValue('NUM', script));
                      if (_num < 1) {
                        num = 1;
                      } else if (_num > 8) {
                        _num = 8;
                      }
                      _numLine = Number.parseInt(script.getNumberValue('NUM_LINE', script));
                      if (_numLine < 1) {
                        _numLine = 1;
                      } else if (_numLine > 8) {
                        _numLine = 8;
                      }
                      _isRow = script.getNumberValue('IS_ROW', script);
                      _value = script.getStringValue('VALUE');
                      _f = function _f(str) {
                        str = str.substring(0, 8);
                        var retVal = '';
                        for (var i = 0; i < str.length; ++i) {
                          if (str[i] === '0' || str[i] === ' ') {
                            retVal += '0';
                          } else {
                            retVal += '1';
                          }
                        }
                        return retVal.padStart(8, '0');
                      };
                      _value = _f(_value);
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 39,
                          params: [_num, _numLine, _isRow, _value]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context56.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context56.stop();
                  }
                }, _callee56);
              }))();
            }
          },
          /*
          CodeWizLite_DotMatrix_Show_Custom_Image: {
              color: EntryStatic.colorSet.block.default.HARDWARE,
              outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
              skeleton: 'basic',
              statements: [],
              params: [
                  {
                      type: 'Block',
                      accept: 'string',
                      value: '1',
                  },
                  {
                      type: 'Led',
                      value: [
                          [0, 0, 0, 0, 0],
                          [0, 1, 1, 0, 0],
                          [1, 1, 1, 1, 1],
                          [1, 1, 1, 1, 1],
                          [0, 1, 1, 1, 1],
                      ],
                  },
                  {
                      type: 'Indicator',
                      img: 'block_icon/hardwarelite_icon.svg',
                      size: 12,
                  },
              ],
              events: {},
              class: 'CodeWizLite_DotMatrix',
              isNotFor: ['CodeWizLite'],
              def: {
                  type: 'CodeWizLite_DotMatrix_Show_Custom_Image',
              },
              paramsKeyMap: {
                  NUM: 0,
                  VALUE: 1,
              },
              async func(sprite, script) {
                  let _num = Number.parseInt(script.getNumberValue('NUM', script));
                  if (_num < 1) {
                      num = 1;
                  } else if (_num > 8) {
                      _num = 8;
                  }
                  const value = script.getField('VALUE');
                  const processedValue = [];
                  for (const i in value) {
                      processedValue[i] = value[i].join('');
                      console.log(processedValue[i]);
                      let _numLine = Number.parseInt(i) + 1;
                      const order = {
                          type: Entry.CodeWizLite.sensorTypes.WRITE,
                          value: {
                              opcode: 39,
                              params: [_num, _numLine, 0, processedValue[i]],
                          },
                      };
                      const id = Entry.CodeWizLite.sendOrder(order);
                      await Entry.CodeWizLite.checkComplete(1000, id);
                  }
                  return;
              },
          },
          */
          CodeWizLite_DotMatrix_setDot: {
            // Block UI : '도트매트릭스 %1번에 %2행%3열 %4%5',
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Dropdown',
              options: [['켜기', '1'], ['끄기', '0']],
              value: '1',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: ['1', '2', '2', null],
              type: 'CodeWizLite_DotMatrix_setDot'
            },
            paramsKeyMap: {
              NUM: 0,
              ROW: 1,
              COL: 2,
              VALUE: 3
            },
            "class": 'CodeWizLite_DotMatrix',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee57() {
                var _num, _numRow, _numCol, _value, order, id;
                return _regenerator["default"].wrap(function (_context57) {
                  while (1) switch (_context57.prev = _context57.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context57.next = 1;
                        break;
                      }
                      _context57.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _num = Number.parseInt(script.getNumberValue('NUM', script));
                      if (_num < 1) {
                        num = 1;
                      } else if (_num > 8) {
                        _num = 8;
                      }
                      _numRow = Number.parseInt(script.getNumberValue('ROW', script));
                      if (_numRow < 1) {
                        _numRow = 1;
                      } else if (_numRow > 8) {
                        _numRow = 8;
                      }
                      _numCol = Number.parseInt(script.getNumberValue('COL', script));
                      if (_numCol < 1) {
                        _numCol = 1;
                      } else if (_numCol > 8) {
                        _numCol = 8;
                      }
                      _value = script.getNumberValue('VALUE', script);
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 40,
                          params: [_num, _numRow, _numCol, _value]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context57.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context57.stop();
                  }
                }, _callee57);
              }))();
            }
          },
          CodeWizLite_DotMatrix_clear: {
            // Block UI : '도트매트릭스 %1번 지우기%2',
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: ['1'],
              type: 'CodeWizLite_DotMatrix_clear'
            },
            paramsKeyMap: {
              NUM: 0
            },
            "class": 'CodeWizLite_DotMatrix',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee58() {
                var _num, order, id;
                return _regenerator["default"].wrap(function (_context58) {
                  while (1) switch (_context58.prev = _context58.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context58.next = 1;
                        break;
                      }
                      _context58.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _num = Number.parseInt(script.getNumberValue('NUM', script));
                      if (_num < 1) {
                        num = 1;
                      } else if (_num > 8) {
                        _num = 8;
                      }
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 41,
                          params: [_num - 1]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context58.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context58.stop();
                  }
                }, _callee58);
              }))();
            }
          },
          CodeWizLite_DotMatrix_clearAll: {
            // Block UI : '도트매트릭스 모두 지우기%1',
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [],
              type: 'CodeWizLite_DotMatrix_clearAll'
            },
            paramsKeyMap: {},
            "class": 'CodeWizLite_DotMatrix',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee59() {
                var order, id;
                return _regenerator["default"].wrap(function (_context59) {
                  while (1) switch (_context59.prev = _context59.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context59.next = 1;
                        break;
                      }
                      _context59.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 41,
                          params: [-1]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context59.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context59.stop();
                  }
                }, _callee59);
              }))();
            }
          },
          CodeWizLite_ColorSensor_title: {
            skeleton: 'basic_text',
            skeletonOptions: {
              box: {
                offsetX: this.getOffsetX(Lang.template.CodeWizLite_ColorSensor_title),
                offsetY: 5
              }
            },
            color: EntryStatic.colorSet.common.TRANSPARENT,
            fontColor: '#333333',
            params: [{
              type: 'Text',
              text: Lang.template.CodeWizLite_ColorSensor_title,
              color: '#333333',
              align: 'left'
            }],
            def: {
              type: 'CodeWizLite_ColorSensor_title'
            },
            "class": 'CodeWizLite_ColorSensor',
            isNotFor: ['CodeWizLite'],
            events: {}
          },
          CodeWizLite_ColorSensor_isColor: {
            // Block UI : "MCON 컬러센서 감지된 색이 %1인가%2",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_boolean_field',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [['빨강', '0'], ['초록', '1'], ['파랑', '2'], ['검정', '3'], ['흰색', '4']],
              value: '0',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null],
              type: 'CodeWizLite_ColorSensor_isColor'
            },
            paramsKeyMap: {
              COLOR: 0
            },
            "class": 'CodeWizLite_ColorSensor',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee60() {
                var _Entry$CodeWizLite$se10, _Entry$CodeWizLite$se11;
                var _color, order, id, retVal;
                return _regenerator["default"].wrap(function (_context60) {
                  while (1) switch (_context60.prev = _context60.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context60.next = 1;
                        break;
                      }
                      _context60.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _color = script.getNumberValue('COLOR', script);
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.READ,
                        value: {
                          opcode: 8,
                          params: [_color]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context60.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                      retVal = (_Entry$CodeWizLite$se10 = (_Entry$CodeWizLite$se11 = Entry.CodeWizLite.sensorData[id]) === null || _Entry$CodeWizLite$se11 === void 0 ? void 0 : _Entry$CodeWizLite$se11.value) !== null && _Entry$CodeWizLite$se10 !== void 0 ? _Entry$CodeWizLite$se10 : false; //delete Entry.CodeWizLite.sensorData[id];
                      return _context60.abrupt("return", retVal);
                    case 3:
                    case "end":
                      return _context60.stop();
                  }
                }, _callee60);
              }))();
            }
          },
          CodeWizLite_ColorSensor_getColorValue: {
            // Block UI : "MCON 컬러센서 %1값%2",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_string_field',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [['빨강', '0'], ['초록', '1'], ['파랑', '2']],
              value: '0',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null],
              type: 'CodeWizLite_ColorSensor_getColorValue'
            },
            paramsKeyMap: {
              COLOR: 0
            },
            "class": 'CodeWizLite_ColorSensor',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee61() {
                var _Entry$CodeWizLite$se12, _Entry$CodeWizLite$se13;
                var _color, order, id, retVal;
                return _regenerator["default"].wrap(function (_context61) {
                  while (1) switch (_context61.prev = _context61.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context61.next = 1;
                        break;
                      }
                      _context61.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _color = script.getNumberValue('COLOR', script);
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.READ,
                        value: {
                          opcode: 9,
                          params: [_color]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context61.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                      retVal = (_Entry$CodeWizLite$se12 = (_Entry$CodeWizLite$se13 = Entry.CodeWizLite.sensorData[id]) === null || _Entry$CodeWizLite$se13 === void 0 ? void 0 : _Entry$CodeWizLite$se13.value) !== null && _Entry$CodeWizLite$se12 !== void 0 ? _Entry$CodeWizLite$se12 : 0; //delete Entry.CodeWizLite.sensorData[id];
                      return _context61.abrupt("return", retVal);
                    case 3:
                    case "end":
                      return _context61.stop();
                  }
                }, _callee61);
              }))();
            }
          },
          CodeWizLite_DHT_title: {
            skeleton: 'basic_text',
            skeletonOptions: {
              box: {
                offsetX: this.getOffsetX(Lang.template.CodeWizLite_DHT_title),
                offsetY: 5
              }
            },
            color: EntryStatic.colorSet.common.TRANSPARENT,
            fontColor: '#333333',
            params: [{
              type: 'Text',
              text: Lang.template.CodeWizLite_DHT_title,
              color: '#333333',
              align: 'left'
            }],
            def: {
              type: 'CodeWizLite_DHT_title'
            },
            "class": 'CodeWizLite_DHT',
            isNotFor: ['CodeWizLite'],
            events: {}
          },
          CodeWizLite_DHT_init: {
            // 디지털 온습도 설정
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [['13', '13'], ['14', '14'], ['15', '15'], ['27', '27'], ['32', '32'], ['33', '33'], ['18', '18'], ['19', '19']],
              value: '18',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null],
              type: 'CodeWizLite_DHT_init'
            },
            paramsKeyMap: {
              PIN: 0
            },
            "class": 'CodeWizLite_DHT',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee62() {
                var _pin, order, id;
                return _regenerator["default"].wrap(function (_context62) {
                  while (1) switch (_context62.prev = _context62.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context62.next = 1;
                        break;
                      }
                      _context62.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _pin = script.getNumberValue('PIN', script);
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 48,
                          params: [_pin]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context62.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context62.stop();
                  }
                }, _callee62);
              }))();
            }
          },
          CodeWizLite_DHT_getValue: {
            // 디지털 온습도 값
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_string_field',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [['℃', '0'], ['℉', '1'], ['습도', '2']],
              value: '0',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null],
              type: 'CodeWizLite_DHT_getValue'
            },
            paramsKeyMap: {
              TYPE: 0
            },
            "class": 'CodeWizLite_DHT',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee63() {
                var _Entry$CodeWizLite$se14, _Entry$CodeWizLite$se15;
                var _type, order, id, retVal;
                return _regenerator["default"].wrap(function (_context63) {
                  while (1) switch (_context63.prev = _context63.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context63.next = 1;
                        break;
                      }
                      _context63.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _type = script.getNumberValue('TYPE', script);
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.READ,
                        value: {
                          opcode: 12,
                          params: [_type]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context63.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                      retVal = (_Entry$CodeWizLite$se14 = (_Entry$CodeWizLite$se15 = Entry.CodeWizLite.sensorData[id]) === null || _Entry$CodeWizLite$se15 === void 0 ? void 0 : _Entry$CodeWizLite$se15.value) !== null && _Entry$CodeWizLite$se14 !== void 0 ? _Entry$CodeWizLite$se14 : 0.0; //delete Entry.CodeWizLite.sensorData[id];
                      return _context63.abrupt("return", retVal);
                    case 3:
                    case "end":
                      return _context63.stop();
                  }
                }, _callee63);
              }))();
            }
          },
          CodeWizLite_Joystick_title: {
            skeleton: 'basic_text',
            skeletonOptions: {
              box: {
                offsetX: this.getOffsetX(Lang.template.CodeWizLite_Joystick_title),
                offsetY: 5
              }
            },
            color: EntryStatic.colorSet.common.TRANSPARENT,
            fontColor: '#333333',
            params: [{
              type: 'Text',
              text: Lang.template.CodeWizLite_Joystick_title,
              color: '#333333',
              align: 'left'
            }],
            def: {
              type: 'CodeWizLite_Joystick_title'
            },
            "class": 'CodeWizLite_Joystick',
            isNotFor: ['CodeWizLite'],
            events: {}
          },
          CodeWizLite_Joystick_setPin: {
            // 조이스틱 설정
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [['32', '32'], ['33', '33'], ['36', '36'], ['39', '39']],
              value: '36',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Dropdown',
              options: [['32', '32'], ['33', '33'], ['36', '36'], ['39', '39']],
              value: '39',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Dropdown',
              options: [['13', '13'], ['14', '14'], ['15', '15'], ['27', '27'], ['18', '18'], ['19', '19']],
              value: '15',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null, null, null, 12],
              type: 'CodeWizLite_Joystick_setPin'
            },
            paramsKeyMap: {
              PIN_X: 0,
              PIN_Y: 1,
              PIN_B: 2,
              RANGE: 3
            },
            "class": 'CodeWizLite_Joystick',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee64() {
                var _pinX, _pinY, _pinB, _range, order, id;
                return _regenerator["default"].wrap(function (_context64) {
                  while (1) switch (_context64.prev = _context64.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context64.next = 1;
                        break;
                      }
                      _context64.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _pinX = script.getNumberValue('PIN_X', script);
                      _pinY = script.getNumberValue('PIN_Y', script);
                      _pinB = script.getNumberValue('PIN_B', script);
                      _range = script.getNumberValue('RANGE', script);
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.WRITE,
                        value: {
                          opcode: 50,
                          params: [_pinX, _pinY, _pinB, _range]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context64.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                    case "end":
                      return _context64.stop();
                  }
                }, _callee64);
              }))();
            }
          },
          CodeWizLite_Joystick_readAxis: {
            // 조이스틱 XY레버값
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_string_field',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [['X축', '0'], ['Y축', '1']],
              value: '0',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null],
              type: 'CodeWizLite_Joystick_readAxis'
            },
            paramsKeyMap: {
              TYPE: 0
            },
            "class": 'CodeWizLite_Joystick',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee65() {
                var _Entry$CodeWizLite$se16, _Entry$CodeWizLite$se17;
                var _type, order, id, retVal;
                return _regenerator["default"].wrap(function (_context65) {
                  while (1) switch (_context65.prev = _context65.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context65.next = 1;
                        break;
                      }
                      _context65.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _type = script.getNumberValue('TYPE', script);
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.READ,
                        value: {
                          opcode: 13,
                          params: [_type]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context65.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                      retVal = (_Entry$CodeWizLite$se16 = (_Entry$CodeWizLite$se17 = Entry.CodeWizLite.sensorData[id]) === null || _Entry$CodeWizLite$se17 === void 0 ? void 0 : _Entry$CodeWizLite$se17.value) !== null && _Entry$CodeWizLite$se16 !== void 0 ? _Entry$CodeWizLite$se16 : 0; //delete Entry.CodeWizLite.sensorData[id];
                      // console.log(_type===0?"X:":"Y:",retVal);
                      return _context65.abrupt("return", retVal);
                    case 3:
                    case "end":
                      return _context65.stop();
                  }
                }, _callee65);
              }))();
            }
          },
          CodeWizLite_Joystick_readButton: {
            // 조이스틱 버튼값
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_boolean_field',
            statements: [],
            params: [{
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null],
              type: 'CodeWizLite_Joystick_readButton'
            },
            paramsKeyMap: {},
            "class": 'CodeWizLite_Joystick',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee66() {
                var _Entry$CodeWizLite$se18, _Entry$CodeWizLite$se19;
                var order, id, retVal;
                return _regenerator["default"].wrap(function (_context66) {
                  while (1) switch (_context66.prev = _context66.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context66.next = 1;
                        break;
                      }
                      _context66.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.READ,
                        value: {
                          opcode: 14,
                          params: []
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context66.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                      retVal = (_Entry$CodeWizLite$se18 = (_Entry$CodeWizLite$se19 = Entry.CodeWizLite.sensorData[id]) === null || _Entry$CodeWizLite$se19 === void 0 ? void 0 : _Entry$CodeWizLite$se19.value) !== null && _Entry$CodeWizLite$se18 !== void 0 ? _Entry$CodeWizLite$se18 : false; //delete Entry.CodeWizLite.sensorData[id];
                      // console.log("Button:",retVal);
                      return _context66.abrupt("return", retVal);
                    case 3:
                    case "end":
                      return _context66.stop();
                  }
                }, _callee66);
              }))();
            }
          },
          CodeWizLite_etcReadSensor_title: {
            skeleton: 'basic_text',
            skeletonOptions: {
              box: {
                offsetX: 5 + this.getOffsetX(Lang.template.CodeWizLite_etcReadSensor_title),
                offsetY: 5
              }
            },
            color: EntryStatic.colorSet.common.TRANSPARENT,
            fontColor: '#333333',
            params: [{
              type: 'Text',
              text: Lang.template.CodeWizLite_etcReadSensor_title,
              color: '#333333',
              align: 'left'
            }],
            def: {
              type: 'CodeWizLite_etcReadSensor_title'
            },
            "class": 'CodeWizLite_etcReadSensor',
            isNotFor: ['CodeWizLite'],
            events: {}
          },
          CodeWizLite_etcReadSensor_mconRead: {
            // 가변저항, 워터센서, 토양수분센서
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_string_field',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [['가변저항', '0'], ['워터센서', '1'], ['토양수분센서', '2']],
              value: '0',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Dropdown',
              options: [['32', '32'], ['33', '33'], ['36', '36'], ['39', '39']],
              value: '36',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null],
              type: 'CodeWizLite_etcReadSensor_mconRead'
            },
            paramsKeyMap: {
              TYPE: 0,
              PIN: 1
            },
            "class": 'CodeWizLite_etcReadSensor',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee67() {
                var _Entry$CodeWizLite$se20, _Entry$CodeWizLite$se21;
                var _type, _pin, order, id, retVal;
                return _regenerator["default"].wrap(function (_context67) {
                  while (1) switch (_context67.prev = _context67.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context67.next = 1;
                        break;
                      }
                      _context67.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _type = script.getNumberValue('TYPE', script);
                      _pin = script.getNumberValue('PIN', script);
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.READ,
                        value: {
                          opcode: 10,
                          params: [_type, _pin]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context67.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                      retVal = (_Entry$CodeWizLite$se20 = (_Entry$CodeWizLite$se21 = Entry.CodeWizLite.sensorData[id]) === null || _Entry$CodeWizLite$se21 === void 0 ? void 0 : _Entry$CodeWizLite$se21.value) !== null && _Entry$CodeWizLite$se20 !== void 0 ? _Entry$CodeWizLite$se20 : 0; //delete Entry.CodeWizLite.sensorData[id];
                      return _context67.abrupt("return", retVal);
                    case 3:
                    case "end":
                      return _context67.stop();
                  }
                }, _callee67);
              }))();
            }
          },
          CodeWizLite_etcReadSensor_digitalRead: {
            // 버튼, 포토인터럽트
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_boolean_field',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [['버튼', '0'], ['포토인터럽트', '1']],
              value: '0',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Dropdown',
              options: [['13', '13'], ['14', '14'], ['15', '15'], ['27', '27'], ['32', '32'], ['33', '33'], ['18', '18'], ['19', '19']],
              value: '18',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null],
              type: 'CodeWizLite_etcReadSensor_digitalRead'
            },
            paramsKeyMap: {
              TYPE: 0,
              PIN: 1
            },
            "class": 'CodeWizLite_etcReadSensor',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee68() {
                var _Entry$CodeWizLite$se22, _Entry$CodeWizLite$se23;
                var _type, _pin, order, id, retVal;
                return _regenerator["default"].wrap(function (_context68) {
                  while (1) switch (_context68.prev = _context68.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context68.next = 1;
                        break;
                      }
                      _context68.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _type = script.getNumberValue('TYPE', script);
                      _pin = script.getNumberValue('PIN', script);
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.READ,
                        value: {
                          opcode: 11,
                          params: [_type, _pin]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context68.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                      retVal = (_Entry$CodeWizLite$se22 = (_Entry$CodeWizLite$se23 = Entry.CodeWizLite.sensorData[id]) === null || _Entry$CodeWizLite$se23 === void 0 ? void 0 : _Entry$CodeWizLite$se23.value) !== null && _Entry$CodeWizLite$se22 !== void 0 ? _Entry$CodeWizLite$se22 : false; //delete Entry.CodeWizLite.sensorData[id];
                      return _context68.abrupt("return", retVal);
                    case 3:
                    case "end":
                      return _context68.stop();
                  }
                }, _callee68);
              }))();
            }
          },
          CodeWizLite_etcReadSensor_InfraredThermometerRead: {
            // Block UI : "비접촉온도센서 %1에 %2로 읽기%3",
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_string_field',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [['SCON', '0'], ['MCON', '1']],
              value: '1',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Dropdown',
              options: [['℃', '0'], ['℉', '1']],
              value: '0',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardware_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null],
              type: 'CodeWizLite_etcReadSensor_InfraredThermometerRead'
            },
            paramsKeyMap: {
              IS_M: 0,
              IS_F: 1
            },
            "class": 'CodeWizLite_etcReadSensor',
            isNotFor: ['CodeWizLite'],
            func: function func(sprite, script) {
              return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee69() {
                var _Entry$CodeWizLite$se24, _Entry$CodeWizLite$se25;
                var _isM, _isF, order, id, retVal;
                return _regenerator["default"].wrap(function (_context69) {
                  while (1) switch (_context69.prev = _context69.next) {
                    case 0:
                      if (!Entry.CodeWizLite.intervalId) {
                        _context69.next = 1;
                        break;
                      }
                      _context69.next = 1;
                      return Entry.CodeWizLite.preWait();
                    case 1:
                      _isM = script.getNumberValue('IS_M', script);
                      _isF = script.getNumberValue('IS_F', script);
                      order = {
                        type: Entry.CodeWizLite.sensorTypes.READ,
                        value: {
                          opcode: 8,
                          params: [_isM, _isF]
                        }
                      };
                      id = Entry.CodeWizLite.sendOrder(order);
                      _context69.next = 2;
                      return Entry.CodeWizLite.checkComplete(1000, id);
                    case 2:
                      retVal = (_Entry$CodeWizLite$se24 = (_Entry$CodeWizLite$se25 = Entry.CodeWizLite.sensorData[id]) === null || _Entry$CodeWizLite$se25 === void 0 ? void 0 : _Entry$CodeWizLite$se25.value) !== null && _Entry$CodeWizLite$se24 !== void 0 ? _Entry$CodeWizLite$se24 : 0; //delete Entry.CodeWizLite.sensorData[id];
                      return _context69.abrupt("return", retVal);
                    case 3:
                    case "end":
                      return _context69.stop();
                  }
                }, _callee69);
              }))();
            }
          }
          //endregion CodeWiz 코드위즈
        };
      }
    }]);
  }())();
})();
module.exports = Entry.CodeWizLite;